webpackJsonp([9],{

/***/ 101:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildAction;
/* unused harmony export delayedAction */
/* unused harmony export fakeProgress */
function buildAction(action, payload) {
  var data = {
    type: action
  };

  if (payload !== undefined) {
    data.payload = payload;
  }

  return data;
}

function delayedAction(minimumTime, workFunction) {
  // Minimum time before dispatching success.
  // You're welcome @ehoekendorf 😘.
  var soonest = Date.now() + minimumTime;

  return new Promise(function (resolve, reject) {
    Promise.resolve(workFunction()).then(function (result) {
      var delay = soonest - Date.now();
      setTimeout(function () {
        resolve(result);
      }, Math.max(delay, 0));
    });
  });
}

function fakeProgress(update) {
  var maxTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2500;
  var fps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;

  var msStep = 1 / maxTime;
  var delay = 1000 / 25; // FPS.

  var last = Date.now();
  var progress = 0;

  var step = function step() {
    var now = Date.now();
    var timeDelta = now - last;
    last = now;

    var progressDelta = msStep * timeDelta * (1 - progress);
    progress = progress + progressDelta;
    update(progressDelta, progress);
  };

  var interval = setInterval(step, delay);

  return function () {
    return clearInterval(interval);
  };
}

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react-cognito/dist/react-cognito.js
var react_cognito = __webpack_require__(55);
var react_cognito_default = /*#__PURE__*/__webpack_require__.n(react_cognito);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(17);

// EXTERNAL MODULE: ./node_modules/whatwg-fetch/fetch.js
var whatwg_fetch_fetch = __webpack_require__(337);
var fetch_default = /*#__PURE__*/__webpack_require__.n(whatwg_fetch_fetch);

// EXTERNAL MODULE: ./src/config.js
var src_config = __webpack_require__(70);
var config_default = /*#__PURE__*/__webpack_require__.n(src_config);

// EXTERNAL MODULE: ./node_modules/crypto-js/sha256.js
var sha256 = __webpack_require__(339);
var sha256_default = /*#__PURE__*/__webpack_require__.n(sha256);

// EXTERNAL MODULE: ./node_modules/crypto-js/enc-hex.js
var enc_hex = __webpack_require__(836);
var enc_hex_default = /*#__PURE__*/__webpack_require__.n(enc_hex);

// EXTERNAL MODULE: ./node_modules/crypto-js/hmac-sha256.js
var hmac_sha256 = __webpack_require__(837);
var hmac_sha256_default = /*#__PURE__*/__webpack_require__.n(hmac_sha256);

// CONCATENATED MODULE: ./src/lib/aws/sigV4Client.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
 * Copyright 2010-2016 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License").
 * You may not use this file except in compliance with the License.
 * A copy of the License is located at
 *
 *  http://aws.amazon.com/apache2.0
 *
 * or in the "license" file accompanying this file. This file is distributed
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the License for the specific language governing
 * permissions and limitations under the License.
 */
/* eslint max-len: ["error", 100]*/





var sigV4Client = {};
sigV4Client.newClient = function (config) {
  var AWS_SHA_256 = 'AWS4-HMAC-SHA256';
  var AWS4_REQUEST = 'aws4_request';
  var AWS4 = 'AWS4';
  var X_AMZ_DATE = 'x-amz-date';
  var X_AMZ_SECURITY_TOKEN = 'x-amz-security-token';
  var HOST = 'host';
  var AUTHORIZATION = 'Authorization';

  function hash(value) {
    return sha256_default()(value); // eslint-disable-line
  }

  function hexEncode(value) {
    return value.toString(enc_hex_default.a);
  }

  function hmac(secret, value) {
    return hmac_sha256_default()(value, secret, { asBytes: true }); // eslint-disable-line
  }

  function buildCanonicalRequest(method, path, queryParams, headers, payload) {
    return method + '\n' + buildCanonicalUri(path) + '\n' + buildCanonicalQueryString(queryParams) + '\n' + buildCanonicalHeaders(headers) + '\n' + buildCanonicalSignedHeaders(headers) + '\n' + hexEncode(hash(payload));
  }

  function hashCanonicalRequest(request) {
    return hexEncode(hash(request));
  }

  function buildCanonicalUri(uri) {
    return encodeURI(uri);
  }

  function buildCanonicalQueryString(queryParams) {
    if (Object.keys(queryParams).length < 1) {
      return '';
    }

    var sortedQueryParams = [];
    for (var property in queryParams) {
      if (queryParams.hasOwnProperty(property)) {
        sortedQueryParams.push(property);
      }
    }
    sortedQueryParams.sort();

    var canonicalQueryString = '';
    for (var i = 0; i < sortedQueryParams.length; i++) {
      canonicalQueryString += sortedQueryParams[i] + '=' + encodeURIComponent(queryParams[sortedQueryParams[i]]) + '&';
    }
    return canonicalQueryString.substr(0, canonicalQueryString.length - 1);
  }

  function buildCanonicalHeaders(headers) {
    var canonicalHeaders = '';
    var sortedKeys = [];
    for (var property in headers) {
      if (headers.hasOwnProperty(property)) {
        sortedKeys.push(property);
      }
    }
    sortedKeys.sort();

    for (var i = 0; i < sortedKeys.length; i++) {
      canonicalHeaders += sortedKeys[i].toLowerCase() + ':' + headers[sortedKeys[i]] + '\n';
    }
    return canonicalHeaders;
  }

  function buildCanonicalSignedHeaders(headers) {
    var sortedKeys = [];
    for (var property in headers) {
      if (headers.hasOwnProperty(property)) {
        sortedKeys.push(property.toLowerCase());
      }
    }
    sortedKeys.sort();

    return sortedKeys.join(';');
  }

  function buildStringToSign(datetime, credentialScope, hashedCanonicalRequest) {
    return AWS_SHA_256 + '\n' + datetime + '\n' + credentialScope + '\n' + hashedCanonicalRequest;
  }

  function buildCredentialScope(datetime, region, service) {
    return datetime.substr(0, 8) + '/' + region + '/' + service + '/' + AWS4_REQUEST;
  }

  function calculateSigningKey(secretKey, datetime, region, service) {
    return hmac(hmac(hmac(hmac(AWS4 + secretKey, datetime.substr(0, 8)), region), service), AWS4_REQUEST);
  }

  function calculateSignature(key, stringToSign) {
    return hexEncode(hmac(key, stringToSign));
  }

  function buildAuthorizationHeader(accessKey, credentialScope, headers, signature) {
    return AWS_SHA_256 + ' Credential=' + accessKey + '/' + credentialScope + ', SignedHeaders=' + buildCanonicalSignedHeaders(headers) + ', Signature=' + signature;
  }

  var awsSigV4Client = {};
  if (config.accessKey === undefined || config.secretKey === undefined) {
    return awsSigV4Client;
  }
  awsSigV4Client.accessKey = config.accessKey;
  awsSigV4Client.secretKey = config.secretKey;
  awsSigV4Client.sessionToken = config.sessionToken;
  awsSigV4Client.serviceName = config.serviceName || 'execute-api';
  awsSigV4Client.region = config.region || 'us-east-1';
  awsSigV4Client.defaultAcceptType = config.defaultAcceptType || 'application/json';
  awsSigV4Client.defaultContentType = config.defaultContentType || 'application/json';

  var invokeUrl = config.endpoint;
  var endpoint = /(^https?:\/\/[^/]+)/g.exec(invokeUrl)[1];
  var pathComponent = invokeUrl.substring(endpoint.length);

  awsSigV4Client.endpoint = endpoint;
  awsSigV4Client.pathComponent = pathComponent;

  awsSigV4Client.signRequest = function (request) {
    var verb = request.method.toUpperCase();
    var path = awsSigV4Client.pathComponent + request.path;
    var queryParams = _extends({}, request.queryParams);
    var headers = _extends({}, request.headers);

    // If the user has not specified an override for Content type the use default
    if (headers['Content-Type'] === undefined) {
      headers['Content-Type'] = awsSigV4Client.defaultContentType;
    }

    // If the user has not specified an override for Accept type the use default
    if (headers.Accept === undefined) {
      headers.Accept = awsSigV4Client.defaultAcceptType;
    }

    var body = _extends({}, request.body);
    // override request body and set to empty when signing GET requests
    if (request.body === undefined || verb === 'GET') {
      body = '';
    } else {
      body = JSON.stringify(body);
    }

    // If there is no body remove the content-type header so it is not included in SigV4 calculation
    if (body === '' || body === undefined || body === null) {
      delete headers['Content-Type'];
    }

    var datetime = new Date().toISOString().replace(/\.\d{3}Z$/, 'Z').replace(/[:-]|\.\d{3}/g, '');
    headers[X_AMZ_DATE] = datetime;
    var parser = new URL(awsSigV4Client.endpoint);
    headers[HOST] = parser.hostname;

    var canonicalRequest = buildCanonicalRequest(verb, path, queryParams, headers, body);
    var hashedCanonicalRequest = hashCanonicalRequest(canonicalRequest);
    var credentialScope = buildCredentialScope(datetime, awsSigV4Client.region, awsSigV4Client.serviceName);
    var stringToSign = buildStringToSign(datetime, credentialScope, hashedCanonicalRequest);
    var signingKey = calculateSigningKey(awsSigV4Client.secretKey, datetime, awsSigV4Client.region, awsSigV4Client.serviceName);
    var signature = calculateSignature(signingKey, stringToSign);
    headers[AUTHORIZATION] = buildAuthorizationHeader(awsSigV4Client.accessKey, credentialScope, headers, signature);
    if (awsSigV4Client.sessionToken !== undefined && awsSigV4Client.sessionToken !== '') {
      headers[X_AMZ_SECURITY_TOKEN] = awsSigV4Client.sessionToken;
    }
    delete headers[HOST];

    var url = awsSigV4Client.endpoint + path;
    var queryString = buildCanonicalQueryString(queryParams);
    if (queryString !== '') {
      url += '?' + queryString;
    }

    // Need to re-attach Content-Type if it is not specified at this point
    if (headers['Content-Type'] === undefined) {
      headers['Content-Type'] = awsSigV4Client.defaultContentType;
    }

    return {
      headers: headers,
      url: url
    };
  };

  return awsSigV4Client;
};

/* harmony default export */ var aws_sigV4Client = (sigV4Client);
// CONCATENATED MODULE: ./src/lib/http.js
// https://gist.github.com/tsdorsey/dff41c99dcc36f07a5eb0f83fa74d487
var HTTP_STATUS_CODE = {
  100: 'Continue',
  101: 'Switching Protocols',
  102: 'Processing', // RFC 2518, obsoleted by RFC 4918
  200: 'OK',
  201: 'Created',
  202: 'Accepted',
  203: 'Non-Authoritative Information',
  204: 'No Content',
  205: 'Reset Content',
  206: 'Partial Content',
  207: 'Multi-Status', // RFC 4918
  208: 'Already Reported',
  226: 'IM Used',
  300: 'Multiple Choices',
  301: 'Moved Permanently',
  302: 'Found',
  303: 'See Other',
  304: 'Not Modified',
  305: 'Use Proxy',
  307: 'Temporary Redirect',
  308: 'Permanent Redirect', // RFC 7238
  400: 'Bad Request',
  401: 'Unauthorized',
  402: 'Payment Required',
  403: 'Forbidden',
  404: 'Not Found',
  405: 'Method Not Allowed',
  406: 'Not Acceptable',
  407: 'Proxy Authentication Required',
  408: 'Request Timeout',
  409: 'Conflict',
  410: 'Gone',
  411: 'Length Required',
  412: 'Precondition Failed',
  413: 'Payload Too Large',
  414: 'URI Too Long',
  415: 'Unsupported Media Type',
  416: 'Range Not Satisfiable',
  417: 'Expectation Failed',
  418: "I'm a teapot", // RFC 2324
  421: 'Misdirected Request',
  422: 'Unprocessable Entity', // RFC 4918
  423: 'Locked', // RFC 4918
  424: 'Failed Dependency', // RFC 4918
  425: 'Unordered Collection', // RFC 4918
  426: 'Upgrade Required', // RFC 2817
  428: 'Precondition Required', // RFC 6585
  429: 'Too Many Requests', // RFC 6585
  431: 'Request Header Fields Too Large', // RFC 6585
  500: 'Internal Server Error',
  501: 'Not Implemented',
  502: 'Bad Gateway',
  503: 'Service Unavailable',
  504: 'Gateway Timeout',
  505: 'HTTP Version Not Supported',
  506: 'Variant Also Negotiates', // RFC 2295
  507: 'Insufficient Storage', // RFC 4918
  508: 'Loop Detected',
  509: 'Bandwidth Limit Exceeded',
  510: 'Not Extended', // RFC 2774
  511: 'Network Authentication Required' // RFC 6585
};

var HTTP_STATUS = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102, // RFC 2518, obsoleted by RFC 4918
  OK: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207, // RFC 4918
  AlreadyReported: 208,
  IMUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  TemporaryRedirect: 307,
  PermanentRedirect: 308, // RFC 7238
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  URITooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418, // RFC 2324
  MisdirectedRequest: 421,
  UnprocessableEntity: 422, // RFC 4918
  Locked: 423, // RFC 4918
  FailedDependency: 424, // RFC 4918
  UnorderedCollection: 425, // RFC 4918
  UpgradeRequired: 426, // RFC 2817
  PreconditionRequired: 428, // RFC 6585
  TooManyRequests: 429, // RFC 6585
  RequestHeaderFieldsTooLarge: 431, // RFC 6585
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HTTPVersionNotSupported: 505,
  VariantAlsoNegotiates: 506, // RFC 2295
  InsufficientStorage: 507, // RFC 4918
  LoopDetected: 508,
  BandwidthLimitExceeded: 509,
  NotExtended: 510, // RFC 2774
  NetworkAuthenticationRequired: 511 // RFC 6585
};
// CONCATENATED MODULE: ./src/lib/aws/api.js
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }







var signAndFetch = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(credentials, _ref2) {
    var path = _ref2.path,
        _ref2$method = _ref2.method,
        method = _ref2$method === undefined ? 'GET' : _ref2$method,
        _ref2$headers = _ref2.headers,
        headers = _ref2$headers === undefined ? constants["l" /* EMPTY_OBJECT */] : _ref2$headers,
        _ref2$queryParams = _ref2.queryParams,
        queryParams = _ref2$queryParams === undefined ? constants["l" /* EMPTY_OBJECT */] : _ref2$queryParams,
        body = _ref2.body,
        endpoint = _ref2.endpoint;
    var signedRequest, bodyString, results, value;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            signedRequest = aws_sigV4Client.newClient({
              accessKey: credentials.accessKeyId,
              secretKey: credentials.secretAccessKey,
              sessionToken: credentials.sessionToken,
              region: config_default.a.api.region,
              endpoint: endpoint || config_default.a.api.licenseUrl
            }).signRequest({
              method: method,
              path: encodeURI(path),
              headers: headers,
              queryParams: queryParams,
              body: body
            });
            bodyString = body ? JSON.stringify(body) : body;
            _context.next = 4;
            return fetch(signedRequest.url, {
              method: method,
              headers: signedRequest.headers,
              body: bodyString
            });

          case 4:
            results = _context.sent;

            if (results.ok) {
              _context.next = 21;
              break;
            }

            value = void 0;
            _context.prev = 7;
            _context.next = 10;
            return results.json();

          case 10:
            value = _context.sent;

            if (value.message) {
              value = value.message;
            }
            _context.next = 20;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context['catch'](7);

            console.warn(_context.t0);
            _context.next = 19;
            return results.text();

          case 19:
            value = _context.sent;

          case 20:
            throw new Error(value);

          case 21:
            if (!(results.status === HTTP_STATUS.NoContent)) {
              _context.next = 23;
              break;
            }

            return _context.abrupt('return');

          case 23:
            return _context.abrupt('return', results.json());

          case 24:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[7, 14]]);
  }));

  return function signAndFetch(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
// EXTERNAL MODULE: ./src/lib/react.js
var react = __webpack_require__(221);

// CONCATENATED MODULE: ./src/actions/api.js
/* harmony export (immutable) */ __webpack_exports__["b"] = invokeApi;
/* harmony export (immutable) */ __webpack_exports__["a"] = api_fetch;
/* unused harmony export refreshLoginIfNeeded */
function api__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }






function invokeApi(fetchOptions) {
  return function () {
    var _ref = api__asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Object(react["d" /* loginStabilized */])(getState);

            case 2:
              _context.next = 4;
              return dispatch(refreshLoginIfNeeded());

            case 4:
              return _context.abrupt('return', signAndFetch(getState().cognito.creds, fetchOptions));

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function api_fetch(url, options) {
  return function (dispatch, getState, context) {
    return context.fetch(url, options);
  };
}

function refreshLoginIfNeeded() {
  return function () {
    var _ref2 = api__asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var cognito, expiresAt, action;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              cognito = getState().cognito;

              if (cognito.user) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt('return');

            case 3:
              if (cognito.creds) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt('return');

            case 5:
              if (cognito.creds.expireTime) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt('return');

            case 7:
              if (!(cognito.state !== react_cognito["CognitoState"].LOGGED_IN)) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt('return');

            case 9:
              expiresAt = Date.parse(cognito.creds.expireTime);

              if (!(expiresAt - constants["f" /* CREDENTIALS_REFRESH_BUFFER */] < Date.now())) {
                _context2.next = 15;
                break;
              }

              _context2.next = 13;
              return Object(react_cognito["performLogin"])(cognito.user, cognito.config);

            case 13:
              action = _context2.sent;
              return _context2.abrupt('return', dispatch(action));

            case 15:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return SET_RUNTIME_VARIABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return MINIMUM_DESCRIPTION_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CREDENTIALS_REFRESH_BUFFER; });
/* unused harmony export BASE_FONT_SIZE_PX */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DEFAULT_SEARCH_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DEFAULT_ITERATION_COUNT; });
/* unused harmony export SAFE_TEXT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return EMPTY_ARRAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return EMPTY_OBJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return SET_MODAL_VISIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return SET_MODAL_PROPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return SET_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return MODAL_LAYOUT; });
/* unused harmony export CLIP_MEDIA_VERSIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLIP_MEDIA_VERSIONS_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CLIP_MEDIA_VERSION_LABELS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLIP_MEDIA_VERSION_GRADED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return LICENSING_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return ONBOARDING_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return SET_CHOSEN_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return SET_ACTIVE_PLAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return SET_COUPON_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return SET_COUPON_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return SET_PAYMENT_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return SET_CHOSEN_SUMMARY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BEGIN_SEARCH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return UPDATE_SEARCH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return END_SEARCH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return LOAD_CLIPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return INDEX_BY_CLIP_SLUG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return INDEX_BY_SCENE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return INDEX_BY_SCENE_SLUG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return LOAD_LICENSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return SET_SUBSCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return SET_SEARCH_TEXT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return TOGGLE_FILTER_FAVORITES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return TOGGLE_FILTER_LICENSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return TOGGLE_SEARCH_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return SET_UI_COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return SET_PROFILE_IMAGE_SRC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COGNITO_LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return SET_SEARCH_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return SEARCH_SOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return QUERY_PARSER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return SORT_DIRECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return PLAN_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return RESPONSIVE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return MARKETING_NAV_LINKS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DASHBOARD_PAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DASHBOARD_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FULL_STYLE; });
var _CLIP_MEDIA_VERSION_L, _CLIP_MEDIA_VERSION_G;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';

var MINIMUM_DESCRIPTION_LENGTH = 3;
var CREDENTIALS_REFRESH_BUFFER = 2 * 60 * 1000;
var BASE_FONT_SIZE_PX = 10;
var DEFAULT_SEARCH_SIZE = 400;
var DEFAULT_ITERATION_COUNT = 1;
var SAFE_TEXT = /[a-z 0-9]*/gi;

var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);

var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);

var SET_MODAL_VISIBLE = 'SET_MODAL_VISIBLE';
var SET_MODAL_PROPS = 'SET_MODAL_PROPS';
var SET_MODAL = 'SET_MODAL';
var MODAL = {
  ONBOARDING: 'ONBOARDING',
  LICENSE_CLIP: 'LICENSE_CLIP'
};
var MODAL_LAYOUT = {
  BACKGROUND: 'BACKGROUND',
  FULL: 'FULL',
  EQUAL_SPLIT: 'EQUAL_SPLIT',
  LEFT: 'LEFT',
  RIGHT: 'RIGHT'
};

var CLIP_MEDIA_VERSIONS = {
  UNGRADED_1080: 'ungraded1080',
  GRADED_1080: 'graded1080',
  UNGRADED_4K: 'ungraded4K',
  GRADED_4K: 'graded4K'
};

var CLIP_MEDIA_VERSIONS_ORDER = [CLIP_MEDIA_VERSIONS.UNGRADED_1080, CLIP_MEDIA_VERSIONS.GRADED_1080, CLIP_MEDIA_VERSIONS.UNGRADED_4K, CLIP_MEDIA_VERSIONS.GRADED_4K];

var CLIP_MEDIA_VERSION_LABELS = (_CLIP_MEDIA_VERSION_L = {}, _defineProperty(_CLIP_MEDIA_VERSION_L, CLIP_MEDIA_VERSIONS.UNGRADED_1080, '1080p ProRes - Ungraded'), _defineProperty(_CLIP_MEDIA_VERSION_L, CLIP_MEDIA_VERSIONS.GRADED_1080, '1080p h.264 - Graded'), _defineProperty(_CLIP_MEDIA_VERSION_L, CLIP_MEDIA_VERSIONS.UNGRADED_4K, '4K ProRes - Ungraded'), _defineProperty(_CLIP_MEDIA_VERSION_L, CLIP_MEDIA_VERSIONS.GRADED_4K, '4K ProRes - Graded'), _CLIP_MEDIA_VERSION_L);

var CLIP_MEDIA_VERSION_GRADED = (_CLIP_MEDIA_VERSION_G = {}, _defineProperty(_CLIP_MEDIA_VERSION_G, CLIP_MEDIA_VERSIONS.UNGRADED_1080, false), _defineProperty(_CLIP_MEDIA_VERSION_G, CLIP_MEDIA_VERSIONS.GRADED_1080, true), _defineProperty(_CLIP_MEDIA_VERSION_G, CLIP_MEDIA_VERSIONS.UNGRADED_4K, false), _defineProperty(_CLIP_MEDIA_VERSION_G, CLIP_MEDIA_VERSIONS.GRADED_4K, true), _CLIP_MEDIA_VERSION_G);

var LICENSING_STEP = {
  LICENSE_DESCRIPTION: 'LICENSE_DESCRIPTION',
  OUT_OF_LICENSES: 'OUT_OF_LICENSES',
  PICK_VERSION: 'PICK_VERSION',
  PLAN: 'PLAN',
  PAY: 'PAY',
  DOWNLOADING: 'DOWNLOADING'
};

var ONBOARDING_STEP = {
  REGISTER: 'REGISTER',
  LOGIN: 'LOGIN',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  RESET_PASSWORD: 'RESET_PASSWORD',
  PLAN: 'PLAN',
  PAY: 'PAY',
  CONFIRM: 'CONFIRM',
  COMPLETE: 'COMPLETE'
};

var PLAN = {
  BASIC: 'BASIC',
  PRO: 'PRO',
  UNLIMITED: 'UNLIMITED',
  WEBINAR: 'WEBINAR'
};

var SET_CHOSEN_PLAN = 'SET_CHOSEN_PLAN';
var SET_ACTIVE_PLAN = 'SET_ACTIVE_PLAN';
var SET_COUPON_CODE = 'SET_COUPON_CODE';
var SET_COUPON_ERROR = 'SET_COUPON_ERROR';
var SET_PAYMENT_ERROR = 'SET_PAYMENT_ERROR';
var SET_CHOSEN_SUMMARY = 'SET_CHOSEN_SUMMARY';
var BEGIN_SEARCH_REQUEST = 'BEGIN_SEARCH_REQUEST';
var UPDATE_SEARCH_REQUEST = 'UPDATE_SEARCH_REQUEST';
var END_SEARCH_REQUEST = 'END_SEARCH_REQUEST';

var LOAD_CLIPS = 'LOAD_CLIPS';
var INDEX_BY_CLIP_SLUG = 'INDEX_BY_CLIP_SLUG';
var INDEX_BY_SCENE_ID = 'INDEX_BY_SCENE_ID';
var INDEX_BY_SCENE_SLUG = 'INDEX_BY_SCENE_SLUG';

var LOAD_LICENSES = 'LOAD_LICENSES';
var SET_SUBSCRIPTION = 'SET_SUBSCRIPTION';

var SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
var TOGGLE_FILTER_FAVORITES = 'TOGGLE_FILTER_FAVORITES';
var TOGGLE_FILTER_LICENSED = 'TOGGLE_FILTER_LICENSED';
var TOGGLE_SEARCH_TAG = 'TOGGLE_SEARCH_TAG';

var SET_UI_COLORS = 'SET_UI_COLORS';
var SET_PROFILE_IMAGE_SRC = 'SET_PROFILE_IMAGE_SRC';
var COGNITO_LOGOUT = 'COGNITO_LOGOUT';

var SET_SEARCH_SOURCE = 'SET_SEARCH_SOURCE';
var SEARCH_SOURCE = {
  ALL_SCENES: 'ALL_SCENES',
  COLLECTIONS: 'COLLECTIONS',
  FEATURED: 'FEATURED'
};

var QUERY_PARSER = {
  SIMPLE: 'simple',
  STRUCTURED: 'structured',
  LUCENE: 'lucene',
  DISMAX: 'dismax'
};
var SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc'
};

var PLAN_STATUS = {
  TRIALING: 'trialing',
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  CANCELED: 'canceled',
  UNPAID: 'unpaid'
};

var RESPONSIVE_SIZE = {
  TINY: 0,
  PHONE: 450,
  TABLET_PORTRAIT: 600,
  TABLET_LANDSCAPE: 900,
  DESKTOP: 1200,
  LARGE_DESKTOP: 1600,
  HUGE: 2400
};

var MARKETING_NAV_LINKS = [{ text: 'HOW IT WORKS', href: '/how-it-works' }, { text: 'PRICING', href: '/pricing' }, { text: 'BROWSE', href: '/browse' }];

var DASHBOARD_PAGE = {
  UPGRADE: 'upgrade',
  PROFILE: 'profile',
  LICENSES: 'licenses',
  SUBSCRIPTION: 'subscription'
};

var DASHBOARD_TITLE = {
  upgrade: 'Upgrade To Nucleus',
  profile: 'Edit Profile',
  licenses: 'Licensed Clips',
  subscription: 'My Subscription'
};

var FULL_STYLE = {
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

/***/ }),

/***/ 193:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 221:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getDisplayName;
/* harmony export (immutable) */ __webpack_exports__["b"] = compose;
/* unused harmony export sleepAsync */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loginStabilized; });
/* harmony export (immutable) */ __webpack_exports__["g"] = validEmail;
/* harmony export (immutable) */ __webpack_exports__["f"] = propsEqual;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MyPureComponent; });
/* unused harmony export depthEqual */
/* harmony export (immutable) */ __webpack_exports__["e"] = noOp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_cognito__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_cognito___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_cognito__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_concat__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_concat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_concat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_eq__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_eq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_eq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_sortBy__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_uniq__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_uniq__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }









function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

// Copied from https://github.com/reactjs/redux/blob/master/src/compose.js
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

function sleepAsync(ms) {
  return new Promise(function (resolve, reject) {
    setTimeout(resolve, ms);
  });
}

var loginStabilized = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(getState) {
    var state;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (false) {
              _context.next = 15;
              break;
            }

            state = getState();

            if (!(state.cognito.state === __WEBPACK_IMPORTED_MODULE_1_react_cognito__["CognitoState"].LOGGING_IN)) {
              _context.next = 7;
              break;
            }

            _context.next = 5;
            return sleepAsync(100);

          case 5:
            _context.next = 13;
            break;

          case 7:
            if (!(state.cognito.state === __WEBPACK_IMPORTED_MODULE_1_react_cognito__["CognitoState"].AUTHENTICATED)) {
              _context.next = 12;
              break;
            }

            _context.next = 10;
            return sleepAsync(100);

          case 10:
            _context.next = 13;
            break;

          case 12:
            return _context.abrupt('return');

          case 13:
            _context.next = 0;
            break;

          case 15:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function loginStabilized(_x) {
    return _ref.apply(this, arguments);
  };
}();

function validEmail(address) {
  var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  return re.test(address);
}

function propsEqual(props, nextProps, keys) {
  var compareFunc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : __WEBPACK_IMPORTED_MODULE_3_lodash_eq___default.a;

  if ((typeof keys === 'undefined' ? 'undefined' : _typeof(keys)) === undefined) {
    compareFunc = keys;
    keys = undefined;
  }

  if (keys === undefined) {
    var propKeys = Object.keys(props);
    var nextPropsKeys = Object.keys(nextProps);
    if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isEqual___default()(propKeys, nextProps)) {
      return false;
    }

    keys = __WEBPACK_IMPORTED_MODULE_6_lodash_uniq___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_concat___default()(propKeys, nextPropsKeys));
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      if (!compareFunc(props[key], nextProps[key])) {
        return false;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return true;
}

var MyPureComponent = function (_React$PureComponent) {
  _inherits(MyPureComponent, _React$PureComponent);

  function MyPureComponent() {
    _classCallCheck(this, MyPureComponent);

    return _possibleConstructorReturn(this, (MyPureComponent.__proto__ || Object.getPrototypeOf(MyPureComponent)).apply(this, arguments));
  }

  _createClass(MyPureComponent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var stateEqual = depthEqual(this.state, nextState);
      var propsEqual = depthEqual(this.props, nextProps, 2);

      if (stateEqual && propsEqual) {
        return false;
      }

      return true;
    }
  }]);

  return MyPureComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

function depthEqual(objA, objB) {
  var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (objA === objB) {
    return true;
  }

  if (depth === 0) {
    return false;
  }

  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
  var nextDepth = Math.max(depth - 1, -1);
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = keysA[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var key = _step2.value;

      if (!bHasOwnProperty(key) || !depthEqual(objA[key], objB[key], nextDepth)) {
        return false;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return true;
}

function noOp() {}

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = showSignup;
/* harmony export (immutable) */ __webpack_exports__["g"] = showLogin;
/* harmony export (immutable) */ __webpack_exports__["i"] = signup;
/* harmony export (immutable) */ __webpack_exports__["e"] = logout;
/* harmony export (immutable) */ __webpack_exports__["a"] = changeEmail;
/* harmony export (immutable) */ __webpack_exports__["c"] = changePassword;
/* harmony export (immutable) */ __webpack_exports__["b"] = changeName;
/* harmony export (immutable) */ __webpack_exports__["j"] = uploadProfileImage;
/* unused harmony export onLogin */
/* harmony export (immutable) */ __webpack_exports__["f"] = setupOnLogin;
/* harmony export (immutable) */ __webpack_exports__["d"] = getStep;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_cognito__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_cognito___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_cognito__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_rollbar__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__clips__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modal__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plan__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__runtime__ = __webpack_require__(354);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












function showSignup() {
  return function (dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__runtime__["a" /* setRuntimeVariable */])('onboardingStep', __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* ONBOARDING_STEP */].REGISTER));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__runtime__["a" /* setRuntimeVariable */])('registrationError', undefined));
    dispatch(__WEBPACK_IMPORTED_MODULE_0_react_cognito__["Action"].beginPasswordResetFlow(undefined, '')); // HACK: Reset any react-cognito error.
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_2__constants__["J" /* SET_MODAL */], __WEBPACK_IMPORTED_MODULE_2__constants__["w" /* MODAL */].ONBOARDING));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__modal__["b" /* showModal */])());
  };
}

function showLogin(modalProps) {
  return function (dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__runtime__["a" /* setRuntimeVariable */])('onboardingStep', __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* ONBOARDING_STEP */].LOGIN));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__runtime__["a" /* setRuntimeVariable */])('loginError', undefined));
    dispatch(__WEBPACK_IMPORTED_MODULE_0_react_cognito__["Action"].beginPasswordResetFlow(undefined, '')); // HACK: Reset any react-cognito error.
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_2__constants__["J" /* SET_MODAL */], __WEBPACK_IMPORTED_MODULE_2__constants__["w" /* MODAL */].ONBOARDING));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_7__modal__["b" /* showModal */])(modalProps));
  };
}

function signup(email, password) {
  return function (dispatch, getState) {
    var _getState$cognito = getState().cognito,
        userPool = _getState$cognito.userPool,
        config = _getState$cognito.config;

    var lowerEmail = email.toLowerCase();

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__runtime__["a" /* setRuntimeVariable */])('registrationError', undefined));

    return new Promise(function (resolve, reject) {
      userPool.signUp(lowerEmail, password, Object(__WEBPACK_IMPORTED_MODULE_0_react_cognito__["mkAttrList"])({ email: lowerEmail }), null, function (err, result) {
        if (err) {
          reject(err);
        } else {
          resolve(result);
        }
      });
    }).then(function (result) {
      if (result.userConfirmed === false) {
        dispatch(__WEBPACK_IMPORTED_MODULE_0_react_cognito__["Action"].confirmationRequired(result.user, lowerEmail));
      } else {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react_cognito__["authenticate"])(lowerEmail, password, userPool, config, dispatch);
      }
    }).catch(function (err) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__runtime__["a" /* setRuntimeVariable */])('registrationError', parseCognitoErrors(err)));
      return Promise.reject(err);
    }).then(function () {
      return __WEBPACK_IMPORTED_MODULE_3__lib_rollbar__["b" /* default */].configure({
        payload: {
          person: {
            id: lowerEmail,
            email: lowerEmail
          }
        }
      });
    });
  };
}

function logout() {
  return function (dispatch, getState) {
    var user = getState().cognito.user;

    if (user) {
      user.signOut();
    }

    __WEBPACK_IMPORTED_MODULE_3__lib_rollbar__["b" /* default */].configure({ payload: { person: __WEBPACK_IMPORTED_MODULE_2__constants__["l" /* EMPTY_OBJECT */] } });

    return dispatch(__WEBPACK_IMPORTED_MODULE_0_react_cognito__["Action"].logout());
    // TODO: Purge user data from state. Reload page?
  };
}

function changeEmail(email) {
  var lowerEmail = email.toLowerCase();

  return function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var cognito;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              cognito = getState().cognito;
              return _context.abrupt('return', new Promise(function (resolve, reject) {
                return cognito.user.updateAttributes([{ Name: 'preferred_username', Value: lowerEmail }], function (err, result) {
                  if (err) {
                    console.log('got an error changing the username', err);
                    reject(err.message);
                  } else {
                    console.log('preferred_username updated!');
                    resolve(result);
                  }
                });
              }).then(function () {
                return __WEBPACK_IMPORTED_MODULE_3__lib_rollbar__["b" /* default */].configure({
                  payload: {
                    person: {
                      id: cognito.attributes.email,
                      email: lowerEmail
                    }
                  }
                });
              }));

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}

function changePassword(oldPassword, newPassword) {
  return function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var user;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              user = getState().cognito.user;
              return _context2.abrupt('return', new Promise(function (resolve, reject) {
                return user.changePassword(oldPassword, newPassword, function (err, result) {
                  if (err) {
                    reject(err.message);
                  } else {
                    resolve(result);
                  }
                });
              }));

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function changeName(givenName, familyName) {
  return function () {
    var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch, getState) {
      var cognito;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              cognito = getState().cognito;
              return _context3.abrupt('return', new Promise(function (resolve, reject) {
                return cognito.user.updateAttributes([{ Name: 'given_name', Value: givenName }, { Name: 'family_name', Value: familyName }], function (err, result) {
                  if (err) {
                    reject(err.message);
                  } else {
                    resolve(result);
                  }
                });
              }).then(function () {
                return __WEBPACK_IMPORTED_MODULE_3__lib_rollbar__["b" /* default */].configure({
                  payload: {
                    person: {
                      id: cognito.attributes.email,
                      username: givenName + ' ' + familyName,
                      email: cognito.user.preferred_username || cognito.attributes.email
                    }
                  }
                });
              }));

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function setProfileImageSrc(src) {
  return Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_2__constants__["N" /* SET_PROFILE_IMAGE_SRC */], src);
}

function getPofileImageKey(sub) {
  if (sub) {
    return 'customer-uploads/' + sub + '/profileimage';
  }
}

function getProfileImageSrc(sub, x) {
  var key = getPofileImageKey(sub);
  if (!key) {
    return;
  }

  var src = 'https://s3.amazonaws.com/' + __WEBPACK_IMPORTED_MODULE_1__config___default.a.api.uploadBucket + '/' + key;
  if (x) {
    src = src + '?x=' + x;
  }
  return src;
}

function uploadProfileImage(file) {
  return function (dispatch, getState) {
    var cognito = getState().cognito;

    AWS.config.credentials = cognito.creds;
    var s3 = new AWS.S3();
    var params = {
      Bucket: __WEBPACK_IMPORTED_MODULE_1__config___default.a.api.uploadBucket,
      Key: getPofileImageKey(cognito.creds.identityId),
      ContentType: file.type,
      Body: file,
      ACL: 'public-read'
    };

    return s3.putObject(params).promise().then(function () {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__api__["a" /* fetch */])(getProfileImageSrc(cognito.creds.identityId), {
        mode: 'no-cors',
        cache: 'reload'
      }));
    }).then(function () {
      return dispatch(setProfileImageSrc(getProfileImageSrc(cognito.creds.identityId, Date.now())));
    });
  };
}

function onLogin() {
  return function (dispatch, getState) {
    var cognito = getState().cognito;

    var username = [cognito.attributes.given_name, cognito.attributes.family_name].join(' ');
    if (username === ' ') {
      username = undefined;
    }

    __WEBPACK_IMPORTED_MODULE_3__lib_rollbar__["b" /* default */].configure({
      payload: {
        person: {
          id: cognito.attributes.email,
          username: username,
          email: cognito.user.preferred_username || cognito.attributes.email
        }
      }
    });
    dispatch(setProfileImageSrc(getProfileImageSrc(cognito.creds.identityId)));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__plan__["b" /* getActiveSubscription */])());
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__clips__["c" /* getLicenses */])());
    // TODO: Load profile.
  };
}

function setupOnLogin(store) {
  var currentLoginState = void 0;

  var handleChange = function handleChange() {
    var nextState = store.getState();
    if (currentLoginState !== nextState.cognito.state) {
      currentLoginState = nextState.cognito.state;
      // We know the state just changed from X -> Y so if Y is LOGGED_IN we know X is not LOGGED_IN.
      if (currentLoginState === __WEBPACK_IMPORTED_MODULE_0_react_cognito__["CognitoState"].LOGGED_IN) {
        store.dispatch(onLogin());
      }
    }
  };

  var unsub = store.subscribe(handleChange);
  handleChange();
  return unsub;
}

function parseCognitoErrors(error) {
  var message = error;
  if (error instanceof Error) {
    message = error.message;
  }
  message = String(message);

  if (message === 'Incorrect username or password.') {
    return 'Incorrect email address or password.';
  }

  if (message.includes("Value at 'password' failed to satisfy constraint")) {
    return 'Password must be at least 8 characters long.';
  }

  if (message.includes('account with the given email already exists.')) {
    return 'That email address is already registered.';
  }

  return message;
}

function getStep(state) {
  // Based on the desired step in the state plus the logged in state of the user return the step they
  // need to complete next to move to the desired step.
  var desiredStep = state.runtime.onboardingStep;
  var userState = state.cognito.state;
  var user = state.cognito.user;

  switch (desiredStep) {
    case __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* ONBOARDING_STEP */].REGISTER:
    case __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* ONBOARDING_STEP */].LOGIN:
      return desiredStep;
  }

  // Must be 'logged in' beyond here.
  if (!user || userState === __WEBPACK_IMPORTED_MODULE_0_react_cognito__["CognitoState"].LOGGED_OUT) {
    // Places you can go while not logged in.
    switch (desiredStep) {
      case __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* ONBOARDING_STEP */].REGISTER:
      case __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* ONBOARDING_STEP */].LOGIN:
      case __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* ONBOARDING_STEP */].FORGOT_PASSWORD:
      case __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* ONBOARDING_STEP */].RESET_PASSWORD:
        return desiredStep;
    }
    return __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* ONBOARDING_STEP */].LOGIN;
  }

  // If the user has to make changes to their account capture them first.
  switch (userState) {
    case __WEBPACK_IMPORTED_MODULE_0_react_cognito__["CognitoState"].NEW_PASSWORD_REQUIRED:
      return __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* ONBOARDING_STEP */].NEW_PASSWORD_REQUIRED;
    case __WEBPACK_IMPORTED_MODULE_0_react_cognito__["CognitoState"].EMAIL_VERIFICATION_REQUIRED:
    case __WEBPACK_IMPORTED_MODULE_0_react_cognito__["CognitoState"].CONFIRMATION_REQUIRED:
      return __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* ONBOARDING_STEP */].CONFIRM;
  }

  // This shouldn't happen but lets catch it.
  if (userState !== __WEBPACK_IMPORTED_MODULE_0_react_cognito__["CognitoState"].LOGGED_IN) {
    console.error('Failed to get a logged in user.', userState, user);
    return __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* ONBOARDING_STEP */].LOGIN;
  }

  if (state.plan.activePlan.name === undefined) {
    if (desiredStep === __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* ONBOARDING_STEP */].COMPLETE) {
      return __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* ONBOARDING_STEP */].PLAN;
    }
  }

  return desiredStep;
}

/***/ }),

/***/ 223:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getNucleusUpgradeData;
/* harmony export (immutable) */ __webpack_exports__["e"] = getPlanTitle;
/* harmony export (immutable) */ __webpack_exports__["d"] = getPlanPrice;
/* harmony export (immutable) */ __webpack_exports__["f"] = setChosenPlan;
/* harmony export (immutable) */ __webpack_exports__["g"] = setCouponCode;
/* harmony export (immutable) */ __webpack_exports__["b"] = getActiveSubscription;
/* harmony export (immutable) */ __webpack_exports__["a"] = cancelSubscription;
/* harmony export (immutable) */ __webpack_exports__["i"] = updatePayment;
/* harmony export (immutable) */ __webpack_exports__["h"] = subscribe;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_pick__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_cognito__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_cognito___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_cognito__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_react__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(17);
var _PLANS;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var PLANS = (_PLANS = {}, _defineProperty(_PLANS, __WEBPACK_IMPORTED_MODULE_7__constants__["z" /* PLAN */].BASIC, {
  TITLE: 'Starter',
  MONTHLY: { price: 49, id: 'starter_monthly_11-15-17' },
  ANNUAL: { price: 29, id: 'starter_annual_11-15-17' }
}), _defineProperty(_PLANS, __WEBPACK_IMPORTED_MODULE_7__constants__["z" /* PLAN */].PRO, {
  TITLE: 'Basic',
  MONTHLY: { price: 99, id: 'basic_monthly_11-15-17' },
  ANNUAL: { price: 79, id: 'basic_annual_11-15-17' }
}), _defineProperty(_PLANS, __WEBPACK_IMPORTED_MODULE_7__constants__["z" /* PLAN */].UNLIMITED, {
  TITLE: 'Unlimited',
  MONTHLY: { price: 249, id: 'unlimited_monthly' },
  ANNUAL: { price: 199, id: 'unlimited_annual' }
}), _defineProperty(_PLANS, __WEBPACK_IMPORTED_MODULE_7__constants__["z" /* PLAN */].WEBINAR, {
  TITLE: 'Unlimited',
  MONTHLY: { price: 199, id: 'unlimited_monthly_reduced' },
  ANNUAL: { price: 149, id: 'unlimited_annual_reduced' }
}), _PLANS);

function getNucleusUpgradeData() {
  return function (dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__api__["b" /* invokeApi */])({
      path: '/transition/data',
      method: 'POST',
      endpoint: __WEBPACK_IMPORTED_MODULE_0__config___default.a.api.mediaUrl
    }));
  };
}

function getPlanTitle(name) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(PLANS, [name, 'TITLE']);
}

function getPlanPrice(name, annual) {
  var periodKey = annual ? 'ANNUAL' : 'MONTHLY';
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(PLANS, [name, periodKey, 'price']);
}

function getPlanId(name, annual) {
  var periodKey = annual ? 'ANNUAL' : 'MONTHLY';
  return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(PLANS, [name, periodKey, 'id']);
}

function getPlanById(stripePlanId) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = Object.keys(PLANS)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var plan = _step.value;

      if (stripePlanId === PLANS[plan].MONTHLY.id) {
        return { name: plan, annual: false };
      } else if (stripePlanId === PLANS[plan].ANNUAL.id) {
        return { name: plan, annual: true };
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return __WEBPACK_IMPORTED_MODULE_7__constants__["l" /* EMPTY_OBJECT */];
}

function setChosenPlan(_ref) {
  var name = _ref.name,
      annual = _ref.annual;

  return function (dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_7__constants__["F" /* SET_CHOSEN_PLAN */], planPayload(name, annual)));
    return dispatch(updatePlanSummary());
  };
}

function setCouponCode(code) {
  return function (dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_7__constants__["I" /* SET_COUPON_ERROR */], undefined));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_7__constants__["H" /* SET_COUPON_CODE */], code));
    return dispatch(updatePlanSummary());
  };
}

function getActiveSubscription() {
  return function (dispatch, getState) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__lib_react__["d" /* loginStabilized */])(getState).then(function () {
      if (getState().cognito.state !== __WEBPACK_IMPORTED_MODULE_3_react_cognito__["CognitoState"].LOGGED_IN) {
        return Promise.resolve(dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_7__constants__["E" /* SET_ACTIVE_PLAN */], {
          plan: undefined,
          status: undefined,
          annual: undefined
        })));
      }

      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__api__["b" /* invokeApi */])({ path: '/v1/subscriptions' })).then(function (results) {
        return setSubscriptionValues(dispatch, results);
      });
    });
  };
}

function cancelSubscription() {
  return function (dispatch) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__api__["b" /* invokeApi */])({ path: '/v1/subscriptions', method: 'DELETE' })).then(function (results) {
      return setSubscriptionValues(dispatch, results);
    });
  };
}

function updatePayment(stripeTokenId) {
  return function (dispatch, getState) {
    var state = getState();
    if (!state.plan.activePlan.name) {
      return Promise.reject('No active plan to update.');
    }

    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__api__["b" /* invokeApi */])({
      path: '/v1/subscriptions',
      method: 'POST',
      body: { stripeToken: stripeTokenId }
    })).then(function (results) {
      return setSubscriptionValues(dispatch, results);
    });
  };
}

function subscribe(stripeTokenId, plan, coupon) {
  return function (dispatch, getState) {
    var cognitoState = getState().cognito;
    var email = cognitoState.attributes.email || cognitoState.user.username;
    var planId = getPlanId(plan.name, plan.annual);
    var params = {
      email: email,
      stripeToken: stripeTokenId,
      planLevel: plan.name,
      stripePlanId: planId
    };

    if (coupon) {
      params['couponCode'] = coupon;
    }

    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__api__["b" /* invokeApi */])({
      path: '/v1/subscriptions',
      method: 'POST',
      body: params
    })).then(function (subscription) {
      return setSubscriptionValues(dispatch, subscription);
    });
  };
}

function setSubscriptionValues(dispatch, subscription) {
  dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_7__constants__["E" /* SET_ACTIVE_PLAN */], __WEBPACK_IMPORTED_MODULE_2_lodash_pick___default()(subscription, ['plan', 'status', 'annual'])));
  dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_7__constants__["R" /* SET_SUBSCRIPTION */], __WEBPACK_IMPORTED_MODULE_2_lodash_pick___default()(subscription, ['licensesMax', 'licensesResetAt', 'licensesUsed', 'legacy', 'canceledAfter'])));
}

function planPayload(name, annual) {
  var payload = {};

  if (name !== undefined) {
    payload.name = name;
  }

  if (annual !== undefined) {
    payload.annual = annual;
  }

  return payload;
}

function updatePlanSummary() {
  return function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var state, couponCode, _state$plan$chosenPla, name, annual, planId, summary, _summary;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              couponCode = state.plan.couponCode;
              _state$plan$chosenPla = state.plan.chosenPlan, name = _state$plan$chosenPla.name, annual = _state$plan$chosenPla.annual;
              planId = getPlanId(name, annual);

              if (planId) {
                _context.next = 6;
                break;
              }

              return _context.abrupt('return');

            case 6:
              _context.prev = 6;
              _context.next = 9;
              return dispatch(getPlanSummary(planId, couponCode));

            case 9:
              summary = _context.sent;

              dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_7__constants__["G" /* SET_CHOSEN_SUMMARY */], summary));
              _context.next = 30;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](6);

              if (!(couponCode === undefined)) {
                _context.next = 19;
                break;
              }

              dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_7__constants__["M" /* SET_PAYMENT_ERROR */], _context.t0.message));
              _context.next = 30;
              break;

            case 19:
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_7__constants__["I" /* SET_COUPON_ERROR */], _context.t0.message));

              _context.prev = 20;
              _context.next = 23;
              return dispatch(getPlanSummary(planId));

            case 23:
              _summary = _context.sent;

              dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_7__constants__["G" /* SET_CHOSEN_SUMMARY */], _summary));
              _context.next = 30;
              break;

            case 27:
              _context.prev = 27;
              _context.t1 = _context['catch'](20);

              dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_7__constants__["M" /* SET_PAYMENT_ERROR */], _context.t1.message));

            case 30:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this, [[6, 13], [20, 27]]);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}

var SUMMARY_CACHE = {};
function getPlanSummary(planId, couponCode) {
  return function () {
    var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch) {
      var queryParams, cacheKey, planInfo, price, title, total;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              queryParams = { stripe_plan_id: planId };

              if (couponCode) {
                queryParams['coupon'] = couponCode;
              }

              cacheKey = planId + '_' + couponCode;


              if (!couponCode) {
                // In the case of no coupon we can just use the local info to get the price.
                planInfo = getPlanById(planId);

                if (planInfo.name) {
                  price = getPlanPrice(planInfo.name, planInfo.annual);
                  title = getPlanTitle(planInfo.name);
                  total = planInfo.annual ? 12 * price : price;


                  SUMMARY_CACHE[cacheKey] = {
                    name: title,
                    total: total,
                    monthly: price,
                    regularMonthly: price,
                    percent_off: null,
                    amount_off: null,
                    discountPostfix: null
                  };
                }
              }

              if (!SUMMARY_CACHE[cacheKey]) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt('return', SUMMARY_CACHE[cacheKey]);

            case 6:
              _context2.next = 8;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__api__["b" /* invokeApi */])({
                path: '/v1/subscriptions/cart',
                queryParams: queryParams
              }));

            case 8:
              SUMMARY_CACHE[cacheKey] = _context2.sent;
              return _context2.abrupt('return', SUMMARY_CACHE[cacheKey]);

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
}

/***/ }),

/***/ 224:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = showModal;
/* harmony export (immutable) */ __webpack_exports__["a"] = hideModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sample__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(17);




function showModal(props) {
  return function (dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_2__constants__["K" /* SET_MODAL_PROPS */], props));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_2__constants__["L" /* SET_MODAL_VISIBLE */], true));
  };
}

function hideModal() {
  return Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_2__constants__["L" /* SET_MODAL_VISIBLE */], false);
}

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bootstrapRollbar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config__);



var ignoredMessages = ['Not a Product'];
var rollbarAccessToken = __WEBPACK_IMPORTED_MODULE_1__config___default.a.analytics.rollbarAccessToken;
var RollbarInstance = void 0;

function bootstrapRollbar(rollbar) {
  if (!rollbarAccessToken) {
    return;
  }

  RollbarInstance = new rollbar({
    accessToken: rollbarAccessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    autoInstrument: true,
    ignoredMessages: ignoredMessages,
    payload: {
      environment: "production"
    }
  });
}

/* harmony default export */ __webpack_exports__["b"] = ({
  global: function global() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* EMPTY_OBJECT */];

    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.global(options);
  },
  configure: function configure() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* EMPTY_OBJECT */];

    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.configure(options);
  },
  debug: function debug(item) {
    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.debug(item);
  },
  info: function info(item) {
    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.info(item);
  },
  warn: function warn(item) {
    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.warn(item);
  },
  warning: function warning(item) {
    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.warning(item);
  },
  error: function error(item) {
    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.error(item);
  },
  critical: function critical(item) {
    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.critical(item);
  }
});

/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_color__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_color___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_color__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var namedColors = {
  white: '#FFFFFF',
  gray: '#4A4A4A',
  black: '#000000',
  shadow1: '#282F37',
  shadow2: '#454E57',
  shadow3: '#848B94',
  shadow4: '#BEC4CC',
  shadow5: '#EDEFF0',
  error: '#D0021B'
};

namedColors.errorDark = __WEBPACK_IMPORTED_MODULE_1_color___default()(namedColors.error).saturationv(93).value(52).string();

var Styles = {
  Colors: _extends({}, namedColors)
};

/* harmony default export */ __webpack_exports__["a"] = (Styles);

/***/ }),

/***/ 352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = springify;
/* harmony export (immutable) */ __webpack_exports__["c"] = springable;
/* harmony export (immutable) */ __webpack_exports__["a"] = invertRange;
/* harmony export (immutable) */ __webpack_exports__["b"] = scrollToElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_motion__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_assignWith__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_assignWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_assignWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_pickBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(17);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






function springify(style) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_3__constants__["l" /* EMPTY_OBJECT */];

  var springOptions = _extends({ precision: 0.001 }, options);
  return __WEBPACK_IMPORTED_MODULE_1_lodash_assignWith___default()({}, springable(style), function (_, value) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react_motion__["spring"])(value, springOptions);
    return value;
  });
}

function springable(style) {
  return __WEBPACK_IMPORTED_MODULE_2_lodash_pickBy___default()(style, Number.isFinite);
}

function invertRange(value) {
  var start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  return value * -1 + start + end;
}

function scrollToElement(element) {
  var rate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2.5;
  var minDuration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
  var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var easing = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : EasingFunctions.easeInOutQuint;

  var bounding = element.getBoundingClientRect();
  var top = bounding.top + window.pageYOffset;
  var dest = top + offset;
  var start = window.pageYOffset;
  var duration = Math.max((Math.max(start, dest) - Math.min(start, dest)) / rate, minDuration);

  var update = function update(value) {
    window.scrollTo(window.scrollX, value);
  };

  return tweenValue(start, dest, update, {
    duration: duration,
    easing: easing
  });
}

function animateValue(duration, step, easing) {
  return new Promise(function (resolve, reject) {
    if (typeof easing != 'function') {
      if (typeof EasingFunctions[easing] !== 'function') {
        throw new Error('easing must be one of the EasingFunctions.');
      }
      easing = EasingFunctions[easing];
    }

    var start = performance.now();

    var update = function update() {
      var timeFactor = Math.min((performance.now() - start) / duration, 1);
      var value = easing(timeFactor);

      step(value);

      if (timeFactor < 1) {
        window.requestAnimationFrame(update);
      } else {
        resolve();
      }
    };

    window.requestAnimationFrame(update);
  });
}

function tweenValue(initialValue, finalValue, step, options) {
  var opts = _extends({ duration: 1, easing: EasingFunctions.linear }, options);
  var rangeOfValue = finalValue - initialValue;

  var update = function update(factor) {
    var value = factor * rangeOfValue + initialValue;
    step(value);
  };

  return animateValue(opts.duration, update, opts.easing);
}

/*
 * Easing Functions - inspired from http://gizma.com/easing/
 * only considering the t value for the range [0, 1] => [0, 1]
 */
var EasingFunctions = {
  // no easing, no acceleration
  linear: function linear(t) {
    return t;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(t) {
    return t * t;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(t) {
    return t * (2 - t);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  },
  // accelerating from zero velocity
  easeInCubic: function easeInCubic(t) {
    return t * t * t;
  },
  // decelerating to zero velocity
  easeOutCubic: function easeOutCubic(t) {
    return --t * t * t + 1;
  },
  // acceleration until halfway, then deceleration
  easeInOutCubic: function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
  },
  // accelerating from zero velocity
  easeInQuart: function easeInQuart(t) {
    return t * t * t * t;
  },
  // decelerating to zero velocity
  easeOutQuart: function easeOutQuart(t) {
    return 1 - --t * t * t * t;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(t) {
    return t * t * t * t * t;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(t) {
    return 1 + --t * t * t * t * t;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuint: function easeInOutQuint(t) {
    return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
  }
};

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setRuntimeVariable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(17);
/* eslint-disable import/prefer-default-export */



function setRuntimeVariable(name, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__constants__["O" /* SET_RUNTIME_VARIABLE */],
    payload: {
      name: name,
      value: value
    }
  };
}

/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory__);
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */



// Navigation manager, e.g. history.push('/home')
// https://github.com/mjackson/history
/* harmony default export */ __webpack_exports__["a"] = (true && __WEBPACK_IMPORTED_MODULE_0_history_createBrowserHistory___default()());

/***/ }),

/***/ 358:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function track(event, data) {
  if (!window.fbq) {
    return;
  }

  try {
    window.fbq('track', event, data);
  } catch (err) {
    // Silence!
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({ track: track });

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = showDownloadClipModal;
/* harmony export (immutable) */ __webpack_exports__["d"] = licenseClip;
/* unused harmony export getClipLicenses */
/* harmony export (immutable) */ __webpack_exports__["c"] = getLicenses;
/* harmony export (immutable) */ __webpack_exports__["a"] = clipDownloadables;
/* harmony export (immutable) */ __webpack_exports__["b"] = downloadClip;
/* unused harmony export showDownloadModal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_cognito__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_cognito___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_cognito__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modal__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plan__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__user__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constants__ = __webpack_require__(17);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }










function showDownloadClipModal(clipId, license, backTo, onBackTo, goTo, onGoTo) {
  return function (dispatch, getState) {
    var state = getState();
    var clip = state.clips.clips[clipId];

    if (state.cognito.state !== __WEBPACK_IMPORTED_MODULE_1_react_cognito__["CognitoState"].LOGGED_IN) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__user__["g" /* showLogin */])({
        onAfterLogin: function onAfterLogin() {
          return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__modal__["a" /* hideModal */])());
        }
      }));
    } else {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_7__constants__["J" /* SET_MODAL */], __WEBPACK_IMPORTED_MODULE_7__constants__["w" /* MODAL */].LICENSE_CLIP));
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__modal__["b" /* showModal */])({
        clip: clip,
        usingLicense: license,
        backTo: backTo,
        onBackTo: onBackTo,
        goTo: goTo,
        onGoTo: onGoTo
      }));
    }
  };
}

function licenseClip(clipId, description) {
  return function () {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(dispatch) {
      var license;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__api__["b" /* invokeApi */])({
                path: '/v1/clips/' + clipId + '/licenses',
                body: { description: description },
                method: 'POST'
              }));

            case 2:
              license = _context.sent;


              dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_7__constants__["t" /* LOAD_LICENSES */], [license]));
              dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__plan__["b" /* getActiveSubscription */])());

              return _context.abrupt('return', license);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function getClipLicenses(clipId) {
  return function () {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(dispatch) {
      var licenses;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__api__["b" /* invokeApi */])({
                path: '/v1/clips/' + clipId + '/licenses'
              }));

            case 2:
              licenses = _context2.sent;


              dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_7__constants__["t" /* LOAD_LICENSES */], licenses));
              return _context2.abrupt('return', licenses);

            case 5:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function getLicenses() {
  return function () {
    var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(dispatch) {
      var licenses;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__api__["b" /* invokeApi */])({
                path: '/v1/licenses'
              }));

            case 2:
              licenses = _context3.sent;


              dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__helpers__["a" /* buildAction */])(__WEBPACK_IMPORTED_MODULE_7__constants__["t" /* LOAD_LICENSES */], licenses));

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
}

function clipDownloadables(clipId) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__api__["b" /* invokeApi */])({
    path: '/v1/clips/' + clipId + '/download'
  });
}

function downloadClip(clipId, version, licensedAt) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__api__["b" /* invokeApi */])({
    path: '/v1/clips/' + clipId + '/download',
    body: { version: version, licensedAt: licensedAt },
    method: 'POST'
  });
}

function showDownloadModal(clipId) {}

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(391);
module.exports = __webpack_require__(593);


/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/history/PathUtils.js
var PathUtils = __webpack_require__(181);
var PathUtils_default = /*#__PURE__*/__webpack_require__.n(PathUtils);

// EXTERNAL MODULE: ./node_modules/lodash/toPairs.js
var toPairs = __webpack_require__(594);
var toPairs_default = /*#__PURE__*/__webpack_require__.n(toPairs);

// EXTERNAL MODULE: ./node_modules/query-string/index.js
var query_string = __webpack_require__(611);
var query_string_default = /*#__PURE__*/__webpack_require__.n(query_string);

// EXTERNAL MODULE: ./node_modules/react/react.js
var react = __webpack_require__(19);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/react-cognito/dist/react-cognito.js
var react_cognito = __webpack_require__(55);
var react_cognito_default = /*#__PURE__*/__webpack_require__.n(react_cognito);

// EXTERNAL MODULE: ./node_modules/react-deep-force-update/lib/index.js
var lib = __webpack_require__(753);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(754);
var react_dom_default = /*#__PURE__*/__webpack_require__.n(react_dom);

// EXTERNAL MODULE: ./node_modules/react-stripe-elements/es/index.js
var es = __webpack_require__(364);
var es_default = /*#__PURE__*/__webpack_require__.n(es);

// EXTERNAL MODULE: ./node_modules/whatwg-fetch/fetch.js
var fetch = __webpack_require__(337);
var fetch_default = /*#__PURE__*/__webpack_require__.n(fetch);

// EXTERNAL MODULE: ./src/actions/user.js
var user = __webpack_require__(222);

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(33);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var react_redux_es = __webpack_require__(220);

// CONCATENATED MODULE: ./src/components/App.js
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */





var ContextType = _extends({
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: prop_types_default.a.func.isRequired,
  // Universal HTTP client
  fetch: prop_types_default.a.func.isRequired
}, react_redux_es["Provider"].childContextTypes);

if (false) {
  var _require = require('why-did-you-update'),
      whyDidYouUpdate = _require.whyDidYouUpdate;

  whyDidYouUpdate(React, {
    groupByComponent: true,
    collapseComponentGroups: true
  });
}

/**
 * The top-level React component setting context (global) variables
 * that can be accessed from all the child components.
 *
 * https://facebook.github.io/react/docs/context.html
 *
 * Usage example:
 *
 *   const context = {
 *     history: createBrowserHistory(),
 *     store: createStore(),
 *   };
 *
 *   ReactDOM.render(
 *     <App context={context}>
 *       <Layout>
 *         <LandingPage />
 *       </Layout>
 *     </App>,
 *     container,
 *   );
 */

var App_App = function (_React$PureComponent) {
  _inherits(App, _React$PureComponent);

  function App() {
    _classCallCheck(this, App);

    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
  }

  _createClass(App, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return this.props.context;
    }
  }, {
    key: 'render',
    value: function render() {
      // NOTE: If you need to add or modify header, footer etc. of the app,
      // please do that inside the Layout component.
      return react_default.a.Children.only(this.props.children);
    }
  }]);

  return App;
}(react_default.a.PureComponent);

App_App.childContextTypes = ContextType;


/* harmony default export */ var components_App = (App_App);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(70);
var config_default = /*#__PURE__*/__webpack_require__.n(config);

// CONCATENATED MODULE: ./src/createFetch.js
var createFetch__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Creates a wrapper function around the HTML5 Fetch API that provides
 * default arguments to fetch(...) and is intended to reduce the amount
 * of boilerplate code in the application.
 * https://developer.mozilla.org/docs/Web/API/Fetch_API/Using_Fetch
 */
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

function createFetch(fetch, _ref) {
  var baseUrl = _ref.baseUrl,
      cookie = _ref.cookie;

  // NOTE: Tweak the default options to suite your application needs
  var defaults = {
    method: 'POST', // handy with GraphQL backends
    mode: baseUrl ? 'cors' : 'same-origin',
    credentials: baseUrl ? 'include' : 'same-origin',
    headers: createFetch__extends({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }, cookie ? { Cookie: cookie } : null)
  };

  return function (url, options) {
    return url.startsWith('/graphql') || url.startsWith('/api') ? fetch('' + baseUrl + url, createFetch__extends({}, defaults, options, {
      headers: createFetch__extends({}, defaults.headers, options && options.headers)
    })) : fetch(url, options);
  };
}

/* harmony default export */ var src_createFetch = (createFetch);
// CONCATENATED MODULE: ./src/DOMUtils.js
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

function updateTag(tagName, keyName, keyValue, attrName, attrValue) {
  var node = document.head.querySelector(tagName + '[' + keyName + '="' + keyValue + '"]');
  if (node && node.getAttribute(attrName) === attrValue) return;

  // Remove and create a new tag in order to make it work with bookmarks in Safari
  if (node) {
    node.parentNode.removeChild(node);
  }
  if (typeof attrValue === 'string') {
    var nextNode = document.createElement(tagName);
    nextNode.setAttribute(keyName, keyValue);
    nextNode.setAttribute(attrName, attrValue);
    document.head.appendChild(nextNode);
  }
}

function updateMeta(name, content) {
  updateTag('meta', 'name', name, 'content', content);
}

function updateCustomMeta(property, content) {
  updateTag('meta', 'property', property, 'content', content);
}

function updateLink(rel, href) {
  updateTag('link', 'rel', rel, 'href', href);
}
// EXTERNAL MODULE: ./src/history.js
var src_history = __webpack_require__(357);

// EXTERNAL MODULE: ./src/lib/facebook.js
var facebook = __webpack_require__(358);

// EXTERNAL MODULE: ./src/lib/Motion.js
var Motion = __webpack_require__(352);

// EXTERNAL MODULE: ./src/lib/rollbar.js
var rollbar = __webpack_require__(338);

// EXTERNAL MODULE: ./node_modules/universal-router/browser.mjs
var browser = __webpack_require__(870);

// CONCATENATED MODULE: ./src/routes/index.js
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable global-require */

// The top-level (parent) route
var routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children: [{
    path: '',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1575));
    }
  }, {
    path: '/how-it-works',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1576));
    }
  }, {
    path: '/pricing',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1577));
    }
  }, {
    path: '/legal',
    load: function load() {
      return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 1578));
    }
  }, {
    path: '/0538b3c4-6c90-422f-9893-63ab9682e42c',
    load: function load() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1579));
    }
  }, {
    path: '/social-media-checklist',
    load: function load() {
      return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1580));
    }
  }, {
    path: '/social-media-program',
    load: function load() {
      return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1581));
    }
  }, {
    path: '/video-course-part-one',
    load: function load() {
      return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1582));
    }
  }, {
    path: '/video-course-part-two',
    load: function load() {
      return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1583));
    }
  }, {
    path: '/video-course-part-three',
    load: function load() {
      return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1584));
    }
  }, {
    path: '/browse',
    children: [{
      path: '',
      load: function load() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1585));
      }
    }, {
      path: '/scene/:sceneSlug',
      load: function load() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1585));
      }
    }, {
      path: '/scene/:sceneSlug/:clipSlug',
      load: function load() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1585));
      }
    }, {
      path: '(.*)',
      load: function load() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1585));
      }
    }]
  }, {
    path: '/dashboard',
    children: [{
      path: '',
      load: function load() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1586));
      }
    }, {
      path: '/profile',
      load: function load() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1586));
      }
    }, {
      path: '/upgrade',
      load: function load() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1586));
      }
    }, {
      path: '/licenses',
      load: function load() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1586));
      }
    }, {
      path: '/subscription',
      load: function load() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1586));
      }
    }, {
      path: '(.*)',
      load: function load() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1586));
      }
    }]
  },

  // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
  {
    path: '(.*)',
    action: function action() {
      return { redirect: '/' };
    }
  }],

  action: function action(_ref) {
    var _this = this;

    var next = _ref.next;
    return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
      var route;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return next();

            case 2:
              route = _context.sent;


              // Provide default values for title, description etc.
              route.title = route.title || 'Storytape - One subscription. Unlimited 4K stock footage video clips.';
              route.description = route.description || 'Storytape is an unlimited stock footage platform. Each month we add more than 500+ new 4K video clips. Browse the full cinematic library for free.';

              return _context.abrupt('return', route);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
};

// The error page is available by permanent url for development mode
if (false) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default
  });
}

/* harmony default export */ var src_routes = (routes);
// CONCATENATED MODULE: ./src/router.js
/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */




/* harmony default export */ var router = (new browser["a" /* default */](src_routes, {
  resolveRoute: function resolveRoute(context, params) {
    if (typeof context.route.load === 'function') {
      return context.route.load().then(function (action) {
        return action.default(context, params);
      });
    }
    if (typeof context.route.action === 'function') {
      return context.route.action(context, params);
    }
    return null;
  }
}));
// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 6 modules
var redux_es = __webpack_require__(196);

// EXTERNAL MODULE: ./node_modules/redux-thunk/lib/index.js
var redux_thunk_lib = __webpack_require__(881);
var redux_thunk_lib_default = /*#__PURE__*/__webpack_require__.n(redux_thunk_lib);

// EXTERNAL MODULE: ./node_modules/lodash/fromPairs.js
var fromPairs = __webpack_require__(368);
var fromPairs_default = /*#__PURE__*/__webpack_require__.n(fromPairs);

// EXTERNAL MODULE: ./node_modules/lodash/isArray.js
var isArray = __webpack_require__(18);
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);

// EXTERNAL MODULE: ./node_modules/lodash/keyBy.js
var keyBy = __webpack_require__(356);
var keyBy_default = /*#__PURE__*/__webpack_require__.n(keyBy);

// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(139);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);

// EXTERNAL MODULE: ./node_modules/lodash/uniq.js
var uniq = __webpack_require__(142);
var uniq_default = /*#__PURE__*/__webpack_require__.n(uniq);

// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(17);

// CONCATENATED MODULE: ./src/reducers/clips.js
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var clips__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }









var defaultState = {
  clips: constants["l" /* EMPTY_OBJECT */],
  indexByClipSlug: constants["l" /* EMPTY_OBJECT */],
  indexBySceneId: constants["l" /* EMPTY_OBJECT */],
  indexBySceneSlug: constants["l" /* EMPTY_OBJECT */]
};

var remapPairs = [];
if (config_default.a.search.staticAssetRemapping !== undefined) {
  remapPairs.splice.apply(remapPairs, [0, 0].concat(_toConsumableArray(config_default.a.search.staticAssetRemapping.split('||').map(function (pair) {
    return pair.split('|');
  }))));
}

var remapAttrs = ['clip_lqip', 'clip_thumbnail', 'clip_poster', 'clip_preview_small', 'clip_preview_large', 'clip_sequence', 'scene_lqip', 'scene_thumbnail', 'scene_poster'];

/* harmony default export */ var clips = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments[1];

  switch (action.type) {
    case constants["o" /* INDEX_BY_CLIP_SLUG */]:
      return mergeIndex(state, 'indexByClipSlug', action.payload);
    case constants["p" /* INDEX_BY_SCENE_ID */]:
      return mergeIndex(state, 'indexBySceneId', action.payload);
    case constants["q" /* INDEX_BY_SCENE_SLUG */]:
      return mergeIndex(state, 'indexBySceneSlug', action.payload);
    case constants["s" /* LOAD_CLIPS */]:
      {
        var newClips = action.payload.map(function (clip) {
          // If we've already processed and stored this clip, skip it.
          if (state.clips[clip.fields.clip_id] !== undefined) {
            return;
          }

          var _clip$fields = clip.fields,
              _score = _clip$fields._score,
              fields = _objectWithoutProperties(_clip$fields, ['_score']);

          fields.tags = parseTags(fields.tags);
          fields.clip_length = parseClipLength(fields.clip_length);
          fields.clip_colors = parseColors(fields.clip_colors);
          fields.scene_colors = parseColors(fields.scene_colors);
          fields.scene_clip_count = parseNumber(fields.scene_clip_count);
          return clips__extends({}, fields, remapStaticAssetPaths(fields));
        });

        var filteredClips = newClips.filter(Boolean);
        if (filteredClips.length === 0) {
          return state;
        }

        var keyedClips = keyBy_default()(filteredClips, 'clip_id');

        return clips__extends({}, state, {
          clips: clips__extends({}, state.clips, keyedClips)
        });
      }
    default:
      return state;
  }
});

// Private funcitons

function parseColors(colors) {
  if (colors === undefined) {
    return constants["k" /* EMPTY_ARRAY */];
  }
  return fromPairs_default()(colors.map(function (color) {
    return color.split(':');
  }));
}

function parseTags(tags) {
  if (tags === undefined) {
    return constants["k" /* EMPTY_ARRAY */];
  }

  return tags.map(Number);
}

function parseClipLength(length) {
  try {
    return Number(length);
  } catch (err) {
    console.warn(err);
    return 0;
  }
}

function parseNumber(input) {
  try {
    return Number(input);
  } catch (err) {
    console.warn(err);
    return input;
  }
}

function mergeIndex(state, indexKey, payload) {
  if (state[indexKey][payload.key] !== undefined) {
    return state;
  }

  return clips__extends({}, state, _defineProperty({}, indexKey, clips__extends({}, state[indexKey], _defineProperty({}, payload.key, payload.value))));
}

function remapStaticAssetPaths(clip) {
  if (remapPairs.length < 1) {
    return constants["l" /* EMPTY_OBJECT */];
  }

  var remappedPairs = remapAttrs.map(function (attr) {
    var value = clip[attr];
    if (value === undefined) {
      return;
    }

    return [attr, remapPath(value)];
  });

  remappedPairs = remappedPairs.filter(Boolean);

  return fromPairs_default()(remappedPairs);
}

function remapPath(item) {
  if (isArray_default()(item)) {
    return item.map(remapPath);
  }

  return remapPairs.reduce(function (acc, next) {
    var _next = _slicedToArray(next, 2),
        from = _next[0],
        to = _next[1];

    return acc.replace(from, to);
  }, item);
}
// EXTERNAL MODULE: ./node_modules/lodash/includes.js
var includes = __webpack_require__(233);
var includes_default = /*#__PURE__*/__webpack_require__.n(includes);

// EXTERNAL MODULE: ./node_modules/lodash/values.js
var values = __webpack_require__(83);
var values_default = /*#__PURE__*/__webpack_require__.n(values);

// CONCATENATED MODULE: ./src/reducers/modal.js
var modal__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var DEFAULT_STATE = {
  visible: false,
  modal: undefined,
  props: constants["l" /* EMPTY_OBJECT */]
};

/* harmony default export */ var modal = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
  var action = arguments[1];

  switch (action.type) {
    case constants["J" /* SET_MODAL */]:
      return modal__extends({}, state, {
        modal: action.payload
      });
    case constants["L" /* SET_MODAL_VISIBLE */]:
      return modal__extends({}, state, {
        visible: action.payload
      });
    case constants["K" /* SET_MODAL_PROPS */]:
      return modal__extends({}, state, {
        props: action.payload || constants["l" /* EMPTY_OBJECT */]
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./node_modules/lodash/pick.js
var pick = __webpack_require__(343);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);

// CONCATENATED MODULE: ./src/reducers/plan.js
var plan__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var plan_DEFAULT_STATE = {
  chosenPlan: { name: constants["z" /* PLAN */].UNLIMITED, annual: true },
  activePlan: { name: undefined, annual: undefined, status: undefined },
  couponCode: undefined,
  couponError: undefined,
  paymentError: undefined,
  chosenSummary: undefined
};

/* harmony default export */ var plan = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : plan_DEFAULT_STATE;
  var action = arguments[1];

  switch (action.type) {
    case constants["e" /* COGNITO_LOGOUT */]:
      return plan__extends({}, state, {
        activePlan: plan_DEFAULT_STATE.activePlan,
        couponCode: plan_DEFAULT_STATE.couponCode,
        couponError: plan_DEFAULT_STATE.couponError,
        paymentError: plan_DEFAULT_STATE.paymentError
      });
    case constants["F" /* SET_CHOSEN_PLAN */]:
      return plan__extends({}, state, {
        chosenPlan: plan__extends({}, state.chosenPlan, action.payload)
      });
    case constants["E" /* SET_ACTIVE_PLAN */]:
      return plan__extends({}, state, {
        activePlan: {
          name: action.payload.plan,
          annual: action.payload.annual,
          status: action.payload.status
        },
        chosenPlan: {
          name: action.payload.plan || state.chosenPlan.name,
          annual: action.payload.annual === undefined ? state.chosenPlan.annual : action.payload.annual
        }
      });
    case constants["H" /* SET_COUPON_CODE */]:
      return plan__extends({}, state, {
        couponCode: action.payload
      });
    case constants["I" /* SET_COUPON_ERROR */]:
      return plan__extends({}, state, {
        couponError: action.payload,
        couponCode: undefined
      });
    case constants["M" /* SET_PAYMENT_ERROR */]:
      return plan__extends({}, state, {
        paymentError: action.payload
      });
    case constants["G" /* SET_CHOSEN_SUMMARY */]:
      return plan__extends({}, state, {
        chosenSummary: action.payload
      });
    default:
      return state;
  }
});
// CONCATENATED MODULE: ./src/reducers/runtime.js
var runtime__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function runtime__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var runtime_DEFAULT_STATE = {
  responsive: 600,
  scrollPrison: false,
  layoutLoading: true,
  layoutLoaded: false
};

/* harmony default export */ var runtime = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : runtime_DEFAULT_STATE;
  var action = arguments[1];

  switch (action.type) {
    case constants["e" /* COGNITO_LOGOUT */]:
      return runtime__extends({}, state, {
        registrationError: undefined,
        loginError: undefined
      });
    case constants["O" /* SET_RUNTIME_VARIABLE */]:
      if (state[action.payload.name] === action.payload.value) {
        return state;
      }
      return runtime__extends({}, state, runtime__defineProperty({}, action.payload.name, action.payload.value));
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./node_modules/lodash/without.js
var without = __webpack_require__(882);
var without_default = /*#__PURE__*/__webpack_require__.n(without);

// CONCATENATED MODULE: ./src/reducers/search.js
var search__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function search__defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var search_DEFAULT_STATE = {
  filterToFavorites: false,
  filterToLicensed: false,
  source: constants["D" /* SEARCH_SOURCE */].ALL_SCENES,
  tags: constants["k" /* EMPTY_ARRAY */],
  text: undefined,
  queries: {
    // someHashValue: {
    //   hit: [clipId],
    //   cursor: '',
    //   found: 0,
    //   fetching: Promise || undefined,
    // },
  }
};

/* harmony default export */ var search = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : search_DEFAULT_STATE;
  var action = arguments[1];

  switch (action.type) {
    case constants["a" /* BEGIN_SEARCH_REQUEST */]:
      return search__extends({}, state, {
        queries: search__extends({}, state.queries, search__defineProperty({}, action.payload.key, search__extends({
          hit: constants["k" /* EMPTY_ARRAY */],
          cursor: undefined,
          found: undefined
        }, state.queries[action.payload.key] || constants["l" /* EMPTY_OBJECT */], {
          fetching: action.payload.fetching
        })))
      });
    case constants["m" /* END_SEARCH_REQUEST */]:
      return search__extends({}, state, {
        queries: search__extends({}, state.queries, search__defineProperty({}, action.payload.key, search__extends({}, state.queries[action.payload.key], {
          fetching: undefined
        })))
      });
    case constants["P" /* SET_SEARCH_SOURCE */]:
      return search__extends({}, state, {
        source: values_default()(constants["D" /* SEARCH_SOURCE */]).includes(action.payload) ? action.payload : state.source
      });
    case constants["Q" /* SET_SEARCH_TEXT */]:
      return search__extends({}, state, {
        text: action.payload
      });
    case constants["U" /* TOGGLE_FILTER_FAVORITES */]:
      return search__extends({}, state, {
        filterToFavorites: action.payload !== undefined ? action.payload : !state.filterToFavorites
      });
    case constants["V" /* TOGGLE_FILTER_LICENSED */]:
      return search__extends({}, state, {
        filterToLicensed: action.payload !== undefined ? action.payload : !state.filterToLicensed
      });
    case constants["W" /* TOGGLE_SEARCH_TAG */]:
      {
        var isInState = state.tags.includes(action.payload.tagId);
        var newState = action.payload.state;
        if (newState === undefined) {
          newState = !isInState;
        }
        var newTags = without_default()(state.tags, action.payload.tagId);
        if (newState) {
          newTags.push(action.payload.tagId);
        }
        return search__extends({}, state, {
          tags: sortBy_default()(uniq_default()(newTags))
        });
      }
    case constants["X" /* UPDATE_SEARCH_REQUEST */]:
      return search__extends({}, state, {
        queries: search__extends({}, state.queries, search__defineProperty({}, action.payload.key, search__extends({}, state.queries[action.payload.key], {
          hit: state.queries[action.payload.key].hit.concat(action.payload.hit),
          cursor: action.payload.cursor,
          found: action.payload.found
        })))
      });
    default:
      return state;
  }
});

function radioToggle(primary, prevState, nextState, others) {
  var primaryState = nextState !== undefined ? nextState : !prevState;
  var result = search__defineProperty({}, primary, primaryState);
  if (others.map !== undefined) {
    others.map(function (other) {
      return result[other] = !primaryState;
    });
  }
  return result;
}
// EXTERNAL MODULE: ./node_modules/lodash/groupBy.js
var groupBy = __webpack_require__(225);
var groupBy_default = /*#__PURE__*/__webpack_require__.n(groupBy);

// EXTERNAL MODULE: ./src/components/Style/Style.js
var Style = __webpack_require__(350);

// CONCATENATED MODULE: ./src/reducers/ui.js
var ui__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var ui_DEFAULT_STATE = {
  colors: {
    dark: Style["a" /* default */].Colors.shadow3,
    light: Style["a" /* default */].Colors.shadow5,
    highlight: Style["a" /* default */].Colors.shadow2
  }
};

/* harmony default export */ var ui = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ui_DEFAULT_STATE;
  var action = arguments[1];

  switch (action.type) {
    case constants["S" /* SET_UI_COLORS */]:
      return ui__extends({}, state, {
        colors: ui__extends({}, ui_DEFAULT_STATE.colors, action.payload)
      });
    default:
      return state;
  }
});
// EXTERNAL MODULE: ./node_modules/lodash/uniqBy.js
var uniqBy = __webpack_require__(883);
var uniqBy_default = /*#__PURE__*/__webpack_require__.n(uniqBy);

// CONCATENATED MODULE: ./src/reducers/user.js
var user__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function user__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var user_DEFAULT_STATE = {
  subscription: constants["l" /* EMPTY_OBJECT */],
  licenses: constants["k" /* EMPTY_ARRAY */],
  profileImageSrc: undefined
};

/* harmony default export */ var reducers_user = (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : user_DEFAULT_STATE;
  var action = arguments[1];

  switch (action.type) {
    case constants["e" /* COGNITO_LOGOUT */]:
      return user__extends({}, state, {
        subscription: user_DEFAULT_STATE.subscription,
        licenses: user_DEFAULT_STATE.licenses
      });
    case constants["t" /* LOAD_LICENSES */]:
      return user__extends({}, state, {
        licenses: uniqBy_default()([].concat(user__toConsumableArray(state.licenses), user__toConsumableArray(action.payload)), function (license) {
          return license.clipId + '_' + license.licensedAt;
        })
      });
    case constants["R" /* SET_SUBSCRIPTION */]:
      return user__extends({}, state, {
        subscription: action.payload
      });
    case constants["N" /* SET_PROFILE_IMAGE_SRC */]:
      if (action.payload === state.profileImageSrc) {
        return state;
      } else {
        return user__extends({}, state, {
          profileImageSrc: action.payload
        });
      }
    default:
      return state;
  }
});

// TODO: Purge data on logout.
// CONCATENATED MODULE: ./src/reducers/index.js










/* harmony default export */ var reducers = (Object(redux_es["c" /* combineReducers */])({
  clips: clips,
  cognito: react_cognito["cognito"],
  modal: modal,
  plan: plan,
  runtime: runtime,
  search: search,
  ui: ui,
  user: reducers_user
}));
// CONCATENATED MODULE: ./src/store/createHelpers.js
function createHelpers__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function createGraphqlRequest(fetch) {
  return function () {
    var _ref = createHelpers__asyncToGenerator(regeneratorRuntime.mark(function _callee(query, variables) {
      var fetchConfig, resp;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fetchConfig = {
                method: 'post',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ query: query, variables: variables }),
                credentials: 'include'
              };
              _context.next = 3;
              return fetch('/graphql', fetchConfig);

            case 3:
              resp = _context.sent;

              if (!(resp.status !== 200)) {
                _context.next = 6;
                break;
              }

              throw new Error(resp.statusText);

            case 6:
              return _context.abrupt('return', resp.json());

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function graphqlRequest(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return graphqlRequest;
  }();
}

function createHelpers(_ref2) {
  var fetch = _ref2.fetch,
      history = _ref2.history;

  return {
    fetch: fetch,
    history: history,
    graphqlRequest: createGraphqlRequest(fetch)
  };
}
// EXTERNAL MODULE: ./node_modules/redux-logger/dist/redux-logger.js
var redux_logger = __webpack_require__(884);
var redux_logger_default = /*#__PURE__*/__webpack_require__.n(redux_logger);

// CONCATENATED MODULE: ./src/store/logger/logger.client.js


function logger_client_createLogger() {
  return Object(redux_logger["createLogger"])({
    collapsed: true
  });
}
// CONCATENATED MODULE: ./src/store/configureStore.js






function configureStore(initialState, helpersConfig) {
  var helpers = createHelpers(helpersConfig);
  var middleware = [redux_thunk_lib_default.a.withExtraArgument(helpers)];

  var enhancer = void 0;

  if (false) {
    middleware.push(createLogger());

    // https://github.com/zalmoxisus/redux-devtools-extension#redux-devtools-extension
    var devToolsExtension = function devToolsExtension(f) {
      return f;
    };
    if (process.env.BROWSER && window.devToolsExtension) {
      devToolsExtension = window.devToolsExtension();
    }

    enhancer = compose(applyMiddleware.apply(undefined, middleware), devToolsExtension);
  } else {
    enhancer = redux_es["a" /* applyMiddleware */].apply(undefined, middleware);
  }

  // See https://github.com/rackt/redux/releases/tag/v3.1.0
  var store = Object(redux_es["d" /* createStore */])(reducers, initialState, enhancer);

  // Hot reload reducers (requires Webpack or Browserify HMR to be enabled)
  if (false) {
    module.hot.accept('../reducers', function () {
      return (
        // eslint-disable-next-line global-require
        store.replaceReducer(require('../reducers').default)
      );
    });
  }

  return store;
}
// EXTERNAL MODULE: ./src/_3rdParty/rollbar/dist/rollbar.noconflict.umd.min.js
var rollbar_noconflict_umd_min = __webpack_require__(885);
var rollbar_noconflict_umd_min_default = /*#__PURE__*/__webpack_require__.n(rollbar_noconflict_umd_min);

// CONCATENATED MODULE: ./src/client.js
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var client__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// Re-render the app when window.location changes
var onLocationChange = function () {
  var _ref = client__asyncToGenerator(regeneratorRuntime.mark(function _callee(location, action) {
    var route;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // Remember the latest scroll position for the previous location
            scrollPositionsHistory[currentLocation.key] = {
              scrollX: window.pageXOffset,
              scrollY: window.pageYOffset
            };
            // Delete stored scroll position for next page if any
            if (action === 'PUSH') {
              delete scrollPositionsHistory[location.key];
            }
            currentLocation = location;

            _context.prev = 3;
            _context.next = 6;
            return router.resolve(client__extends({}, context, {
              pathname: location.pathname,
              query: query_string_default.a.parse(location.search)
            }));

          case 6:
            route = _context.sent;

            if (!(currentLocation.key !== location.key)) {
              _context.next = 9;
              break;
            }

            return _context.abrupt('return');

          case 9:
            if (!route.redirect) {
              _context.next = 12;
              break;
            }

            src_history["a" /* default */].replace(route.redirect);
            return _context.abrupt('return');

          case 12:

            appInstance = react_dom_default.a.render(_jsx(components_App, {
              context: context
            }, void 0, _jsx(es["StripeProvider"], {
              apiKey: config_default.a.stripe.pk
            }, void 0, route.component)), container, function () {
              return onRenderComplete(route, location);
            });
            _context.next = 21;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context['catch'](3);

            if (true) {
              _context.next = 19;
              break;
            }

            throw _context.t0;

          case 19:

            console.error(_context.t0);

            // Do a full page reload if error occurs during client-side navigation
            if (action && currentLocation.key === location.key) {
              window.location.reload();
            }

          case 21:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 15]]);
  }));

  return function onLocationChange(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

// Handle client-side navigation by using HTML5 History API
// For more information visit https://github.com/mjackson/history#readme


function client__asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function client__toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */























Object(rollbar["a" /* bootstrapRollbar */])(rollbar_noconflict_umd_min_default.a);

/* eslint-disable global-require */

var client_fetch = src_createFetch(self.fetch, {
  baseUrl: window.App.apiUrl
});
// Global (context) variables that can be easily accessed from any React component
// https://facebook.github.io/react/docs/context.html
var context = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  insertCss: function insertCss() {
    for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
      styles[_key] = arguments[_key];
    }

    // eslint-disable-next-line no-underscore-dangle
    var removeCss = styles.map(function (x) {
      return x._insertCss();
    });
    return function () {
      removeCss.forEach(function (f) {
        return f();
      });
    };
  },
  // Universal HTTP client
  fetch: client_fetch,
  // Initialize a new Redux store
  // http://redux.js.org/docs/basics/UsageWithReact.html
  store: configureStore(window.App.state, { fetch: client_fetch, history: src_history["a" /* default */] }),
  storeSubscription: null
};

// Load congito and try to login with any locally stored credentials.
Object(react_cognito["setupCognito"])(context.store, config_default.a.cognito);
Object(user["f" /* setupOnLogin */])(context.store);

// Switch off the native scroll restoration behavior and handle it manually
// https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
var scrollPositionsHistory = {};
if (window.history && 'scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

var onRenderComplete = function initialRenderComplete() {
  var elem = document.getElementById('css');
  if (elem) elem.parentNode.removeChild(elem);
  onRenderComplete = function renderComplete(route, location) {
    document.title = route.title;

    updateMeta('description', route.description);
    toPairs_default()(route.metaTags || {}).map(function (pair) {
      return updateMeta.apply(undefined, client__toConsumableArray(pair));
    });

    // Update necessary tags in <head> at runtime here, ie:
    // updateMeta('keywords', route.keywords);
    // updateCustomMeta('og:url', route.canonicalUrl);
    // updateCustomMeta('og:image', route.imageUrl);
    // updateLink('canonical', route.canonicalUrl);
    // etc.

    var pos = scrollPositionsHistory[location.key];
    var targetHash = location.hash.substr(1);
    var target = document.getElementById(targetHash);

    if (pos) {
      // Restore the scroll position if it was saved into the state
      window.scrollTo(pos.scrollX, pos.scrollY);
    } else if (target) {
      // or scroll to the given #hash anchor
      Object(Motion["b" /* scrollToElement */])(target);
    } else {
      // or scroll to top of the page
      window.scrollTo(0, 0);
    }

    // Google Analytics tracking. Don't send 'pageview' event after
    // the initial rendering, as it was already sent
    if (window.ga) {
      window.ga('send', 'pageview', Object(PathUtils["createPath"])(location));
    }

    // Track pageview for facebook.
    facebook["a" /* default */].track('PageView');
  };
};

var container = document.getElementById('app');
var appInstance = void 0;
var currentLocation = src_history["a" /* default */].location;src_history["a" /* default */].listen(onLocationChange);
onLocationChange(currentLocation);

// Enable Hot Module Replacement (HMR)
if (false) {
  module.hot.accept('./router', function () {
    if (appInstance) {
      // Force-update the whole tree, including components that refuse to update
      deepForceUpdate(appInstance);
    }

    onLocationChange(currentLocation);
  });
}

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

if (true) {
  module.exports = window.App.config;
} else {
  module.exports = {
    api: {
      licenseUrl: process.env.LICENSE_URL,
      mediaUrl: process.env.MEDIA_URL,
      region: process.env.API_REGION,
      uploadBucket: process.env.USER_UPLOAD_BUCKET
    },

    search: {
      endpoint: process.env.SEARCH_URL,
      staticAssetRemapping: process.env.STATIC_ASSET_PATH_REMAPPING
    },

    cognito: {
      userPool: process.env.COGNITO_USER_POOL_ID,
      identityPool: process.env.COGNITO_IDENTITY_POOL_ID,
      clientId: process.env.COGNITO_APP_CLIENT_ID,
      region: process.env.COGNITO_REGION
    },

    stripe: {
      pk: process.env.STRIPE_PK
    },

    // Web analytics
    analytics: {
      // https://analytics.google.com/
      googleTrackingId: process.env.GOOGLE_TRACKING_ID, // UA-XXXXX-X

      // https://rollbar.com
      rollbarAccessToken: process.env.ROLLBAR_CLIENT_ACCESS_TOKEN,

      // https://www.hotjar.com
      hjid: process.env.HOTJAR_ID,

      proofAccId: process.env.PROOF_ACC_ID,

      facebookPixelId: process.env.FACEBOOK_PIXEL_ID
    },

    url: {
      supportEmailAddress: process.env.SUPPORT_EMAIL_ADDRESS
    }
  };
}

/***/ }),

/***/ 885:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

!function (t, e) {
  "object" == ( false ? "undefined" : _typeof(exports)) && "object" == ( false ? "undefined" : _typeof(module)) ? module.exports = e() :  true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.rollbar = e() : t.rollbar = e();
}(this, function () {
  return function (t) {
    function e(r) {
      if (n[r]) return n[r].exports;var o = n[r] = { exports: {}, id: r, loaded: !1 };return t[r].call(o.exports, o, o.exports, e), o.loaded = !0, o.exports;
    }var n = {};return e.m = t, e.c = n, e.p = "", e(0);
  }([function (t, e, n) {
    t.exports = n(1);
  }, function (t, e, n) {
    "use strict";
    var r = n(2);window && !window._rollbarStartTime && (window._rollbarStartTime = new Date().getTime()), t.exports = r;
  }, function (t, e, n) {
    "use strict";
    function r(t, e) {
      this.options = c.extend(!0, _, t);var n = new l(this.options, h, d);this.client = e || new u(this.options, n, p, "browser"), i(this.client.notifier), a(this.client.queue), (this.options.captureUncaught || this.options.handleUncaughtExceptions) && (f.captureUncaughtExceptions(window, this), f.wrapGlobals(window, this)), (this.options.captureUnhandledRejections || this.options.handleUnhandledRejections) && f.captureUnhandledRejections(window, this), this.instrumenter = new b(this.options, this.client.telemeter, this, window, document), this.instrumenter.instrument();
    }function o(t) {
      var e = "Rollbar is not initialized";p.error(e), t && t(new Error(e));
    }function i(t) {
      t.addTransform(m.handleItemWithError).addTransform(m.ensureItemHasSomethingToSay).addTransform(m.addBaseInfo).addTransform(m.addRequestInfo(window)).addTransform(m.addClientInfo(window)).addTransform(m.addPluginInfo(window)).addTransform(m.addBody).addTransform(g.addMessageWithError).addTransform(g.addTelemetryData).addTransform(m.scrubPayload).addTransform(m.userTransform).addTransform(g.itemToPayload);
    }function a(t) {
      t.addPredicate(v.checkIgnore).addPredicate(v.userCheckIgnore).addPredicate(v.urlIsNotBlacklisted).addPredicate(v.urlIsWhitelisted).addPredicate(v.messageIsIgnored);
    }function s(t) {
      for (var e = 0, n = t.length; e < n; ++e) {
        if (c.isFunction(t[e])) return t[e];
      }
    }var u = n(3),
        c = n(6),
        l = n(11),
        p = n(13),
        f = n(16),
        h = n(17),
        d = n(18),
        m = n(19),
        g = n(23),
        v = n(24),
        y = n(20),
        b = n(25),
        w = null;r.init = function (t, e) {
      return w ? w.global(t).configure(t) : w = new r(t, e);
    }, r.prototype.global = function (t) {
      return this.client.global(t), this;
    }, r.global = function (t) {
      return w ? w.global(t) : void o();
    }, r.prototype.configure = function (t, e) {
      var n = this.options,
          r = {};return e && (r = { payload: e }), this.options = c.extend(!0, {}, n, t, r), this.client.configure(t, e), this.instrumenter.configure(t), this;
    }, r.configure = function (t, e) {
      return w ? w.configure(t, e) : void o();
    }, r.prototype.lastError = function () {
      return this.client.lastError;
    }, r.lastError = function () {
      return w ? w.lastError() : void o();
    }, r.prototype.log = function () {
      var t = this._createItem(arguments),
          e = t.uuid;return this.client.log(t), { uuid: e };
    }, r.log = function () {
      if (w) return w.log.apply(w, arguments);var t = s(arguments);o(t);
    }, r.prototype.debug = function () {
      var t = this._createItem(arguments),
          e = t.uuid;return this.client.debug(t), { uuid: e };
    }, r.debug = function () {
      if (w) return w.debug.apply(w, arguments);var t = s(arguments);o(t);
    }, r.prototype.info = function () {
      var t = this._createItem(arguments),
          e = t.uuid;return this.client.info(t), { uuid: e };
    }, r.info = function () {
      if (w) return w.info.apply(w, arguments);var t = s(arguments);o(t);
    }, r.prototype.warn = function () {
      var t = this._createItem(arguments),
          e = t.uuid;return this.client.warn(t), { uuid: e };
    }, r.warn = function () {
      if (w) return w.warn.apply(w, arguments);var t = s(arguments);o(t);
    }, r.prototype.warning = function () {
      var t = this._createItem(arguments),
          e = t.uuid;return this.client.warning(t), { uuid: e };
    }, r.warning = function () {
      if (w) return w.warning.apply(w, arguments);var t = s(arguments);o(t);
    }, r.prototype.error = function () {
      var t = this._createItem(arguments),
          e = t.uuid;return this.client.error(t), { uuid: e };
    }, r.error = function () {
      if (w) return w.error.apply(w, arguments);var t = s(arguments);o(t);
    }, r.prototype.critical = function () {
      var t = this._createItem(arguments),
          e = t.uuid;return this.client.critical(t), { uuid: e };
    }, r.critical = function () {
      if (w) return w.critical.apply(w, arguments);var t = s(arguments);o(t);
    }, r.prototype.handleUncaughtException = function (t, e, n, r, o, i) {
      var a,
          s = c.makeUnhandledStackInfo(t, e, n, r, o, "onerror", "uncaught exception", y);c.isError(o) ? (a = this._createItem([t, o, i]), a._unhandledStackInfo = s) : c.isError(e) ? (a = this._createItem([t, e, i]), a._unhandledStackInfo = s) : (a = this._createItem([t, i]), a.stackInfo = s), a.level = this.options.uncaughtErrorLevel, a._isUncaught = !0, this.client.log(a);
    }, r.prototype.handleUnhandledRejection = function (t, e) {
      var n = "unhandled rejection was null or undefined!";n = t ? t.message || String(t) : n;var r,
          o = t && t._rollbarContext || e && e._rollbarContext;c.isError(t) ? r = this._createItem([n, t, o]) : (r = this._createItem([n, t, o]), r.stackInfo = c.makeUnhandledStackInfo(n, "", 0, 0, null, "unhandledrejection", "", y)), r.level = this.options.uncaughtErrorLevel, r._isUncaught = !0, r._originalArgs = r._originalArgs || [], r._originalArgs.push(e), this.client.log(r);
    }, r.prototype.wrap = function (t, e, n) {
      try {
        var r;if (r = c.isFunction(e) ? e : function () {
          return e || {};
        }, !c.isFunction(t)) return t;if (t._isWrap) return t;if (!t._rollbar_wrapped && (t._rollbar_wrapped = function () {
          n && c.isFunction(n) && n.apply(this, arguments);try {
            return t.apply(this, arguments);
          } catch (n) {
            var e = n;throw c.isType(e, "string") && (e = new String(e)), e._rollbarContext = r() || {}, e._rollbarContext._wrappedSource = t.toString(), window._rollbarWrappedError = e, e;
          }
        }, t._rollbar_wrapped._isWrap = !0, t.hasOwnProperty)) for (var o in t) {
          t.hasOwnProperty(o) && (t._rollbar_wrapped[o] = t[o]);
        }return t._rollbar_wrapped;
      } catch (e) {
        return t;
      }
    }, r.wrap = function (t, e) {
      return w ? w.wrap(t, e) : void o();
    }, r.prototype.captureEvent = function (t, e) {
      return this.client.captureEvent(t, e);
    }, r.captureEvent = function (t, e) {
      return w ? w.captureEvent(t, e) : void o();
    }, r.prototype.captureDomContentLoaded = function (t, e) {
      return e || (e = new Date()), this.client.captureDomContentLoaded(e);
    }, r.prototype.captureLoad = function (t, e) {
      return e || (e = new Date()), this.client.captureLoad(e);
    }, r.prototype._createItem = function (t) {
      return c.createItem(t, p, this);
    };var _ = { version: "2.3.1", scrubFields: ["pw", "pass", "passwd", "password", "secret", "confirm_password", "confirmPassword", "password_confirmation", "passwordConfirmation", "access_token", "accessToken", "secret_key", "secretKey", "secretToken"], logLevel: "debug", reportLevel: "debug", uncaughtErrorLevel: "error", endpoint: "api.rollbar.com/api/1/item/", verbose: !1, enabled: !0 };t.exports = r;
  }, function (t, e, n) {
    "use strict";
    function r(t, e, n, o) {
      this.options = u.extend(!0, {}, t), this.logger = n, r.rateLimiter.configureGlobal(this.options), r.rateLimiter.setPlatformOptions(o, this.options), this.queue = new i(r.rateLimiter, e, n, this.options), this.notifier = new a(this.queue, this.options), this.telemeter = new s(this.options), this.lastError = null;
    }var o = n(4),
        i = n(5),
        a = n(9),
        s = n(10),
        u = n(6),
        c = { maxItems: 0, itemsPerMinute: 60 };r.rateLimiter = new o(c), r.prototype.global = function (t) {
      return r.rateLimiter.configureGlobal(t), this;
    }, r.prototype.configure = function (t, e) {
      this.notifier && this.notifier.configure(t), this.telemeter && this.telemeter.configure(t);var n = this.options,
          r = {};return e && (r = { payload: e }), this.options = u.extend(!0, {}, n, t, r), this.global(this.options), this;
    }, r.prototype.log = function (t) {
      var e = this._defaultLogLevel();return this._log(e, t);
    }, r.prototype.debug = function (t) {
      this._log("debug", t);
    }, r.prototype.info = function (t) {
      this._log("info", t);
    }, r.prototype.warn = function (t) {
      this._log("warning", t);
    }, r.prototype.warning = function (t) {
      this._log("warning", t);
    }, r.prototype.error = function (t) {
      this._log("error", t);
    }, r.prototype.critical = function (t) {
      this._log("critical", t);
    }, r.prototype.wait = function (t) {
      this.queue.wait(t);
    }, r.prototype.captureEvent = function (t, e) {
      return this.telemeter.captureEvent(t, e);
    }, r.prototype.captureDomContentLoaded = function (t) {
      return this.telemeter.captureDomContentLoaded(t);
    }, r.prototype.captureLoad = function (t) {
      return this.telemeter.captureLoad(t);
    }, r.prototype._log = function (t, e) {
      if (!this._sameAsLastError(e)) try {
        var n = null;e.callback && (n = e.callback, delete e.callback), e.level = e.level || t, e.telemetryEvents = this.telemeter.copyEvents(), this.telemeter._captureRollbarItem(e), this.notifier.log(e, n);
      } catch (t) {
        this.logger.error(t);
      }
    }, r.prototype._defaultLogLevel = function () {
      return this.options.logLevel || "debug";
    }, r.prototype._sameAsLastError = function (t) {
      return !(!this.lastError || this.lastError !== t.err) || (this.lastError = t.err, !1);
    }, t.exports = r;
  }, function (t, e) {
    "use strict";
    function n(t) {
      this.startTime = new Date().getTime(), this.counter = 0, this.perMinCounter = 0, this.platform = null, this.platformOptions = {}, this.configureGlobal(t);
    }function r(t, e, n) {
      return !t.ignoreRateLimit && e >= 1 && n > e;
    }function o(t, e, n, r, o) {
      var a = null;return n && (n = new Error(n)), n || r || (a = i(t, e, o)), { error: n, shouldSend: r, payload: a };
    }function i(t, e, n) {
      var r = e.environment || e.payload && e.payload.environment,
          o = { body: { message: { body: "maxItems has been hit. Ignoring errors until reset.", extra: { maxItems: n } } }, language: "javascript", environment: r, notifier: { version: e.notifier && e.notifier.version || e.version } };return "browser" === t ? (o.platform = "browser", o.framework = "browser-js", o.notifier.name = "rollbar-browser-js") : "server" === t ? (o.framework = e.framework || "node-js", o.notifier.name = e.notifier.name) : "react-native" === t && (o.framework = e.framework || "react-native", o.notifier.name = e.notifier.name), o;
    }n.globalSettings = { startTime: new Date().getTime(), maxItems: void 0, itemsPerMinute: void 0 }, n.prototype.configureGlobal = function (t) {
      void 0 !== t.startTime && (n.globalSettings.startTime = t.startTime), void 0 !== t.maxItems && (n.globalSettings.maxItems = t.maxItems), void 0 !== t.itemsPerMinute && (n.globalSettings.itemsPerMinute = t.itemsPerMinute);
    }, n.prototype.shouldSend = function (t, e) {
      e = e || new Date().getTime(), e - this.startTime >= 6e4 && (this.startTime = e, this.perMinCounter = 0);var i = n.globalSettings.maxItems,
          a = n.globalSettings.itemsPerMinute;if (r(t, i, this.counter)) return o(this.platform, this.platformOptions, i + " max items reached", !1);if (r(t, a, this.perMinCounter)) return o(this.platform, this.platformOptions, a + " items per minute reached", !1);this.counter++, this.perMinCounter++;var s = !r(t, i, this.counter);return s = s && !r(t, a, this.perMinCounter), o(this.platform, this.platformOptions, null, s, i);
    }, n.prototype.setPlatformOptions = function (t, e) {
      this.platform = t, this.platformOptions = e;
    }, t.exports = n;
  }, function (t, e, n) {
    "use strict";
    function r(t, e, n, r) {
      this.rateLimiter = t, this.api = e, this.logger = n, this.options = r, this.predicates = [], this.pendingItems = [], this.pendingRequests = [], this.retryQueue = [], this.retryHandle = null, this.waitCallback = null, this.waitIntervalID = null;
    }var o = n(6);r.prototype.configure = function (t) {
      this.api && this.api.configure(t);var e = this.options;return this.options = o.extend(!0, {}, e, t), this;
    }, r.prototype.addPredicate = function (t) {
      return o.isFunction(t) && this.predicates.push(t), this;
    }, r.prototype.addPendingItem = function (t) {
      this.pendingItems.push(t);
    }, r.prototype.removePendingItem = function (t) {
      var e = this.pendingItems.indexOf(t);e !== -1 && this.pendingItems.splice(e, 1);
    }, r.prototype.addItem = function (t, e, n, r) {
      e && o.isFunction(e) || (e = function e() {});var i = this._applyPredicates(t);if (i.stop) return this.removePendingItem(r), void e(i.err);this._maybeLog(t, n), this.removePendingItem(r), this.pendingRequests.push(t);try {
        this._makeApiRequest(t, function (n, r) {
          this._dequeuePendingRequest(t), e(n, r);
        }.bind(this));
      } catch (n) {
        this._dequeuePendingRequest(t), e(n);
      }
    }, r.prototype.wait = function (t) {
      o.isFunction(t) && (this.waitCallback = t, this._maybeCallWait() || (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitIntervalID = setInterval(function () {
        this._maybeCallWait();
      }.bind(this), 500)));
    }, r.prototype._applyPredicates = function (t) {
      for (var e = null, n = 0, r = this.predicates.length; n < r; n++) {
        if (e = this.predicates[n](t, this.options), !e || void 0 !== e.err) return { stop: !0, err: e.err };
      }return { stop: !1, err: null };
    }, r.prototype._makeApiRequest = function (t, e) {
      var n = this.rateLimiter.shouldSend(t);n.shouldSend ? this.api.postItem(t, function (n, r) {
        n ? this._maybeRetry(n, t, e) : e(n, r);
      }.bind(this)) : n.error ? e(n.error) : this.api.postItem(n.payload, e);
    };var i = ["ECONNRESET", "ENOTFOUND", "ESOCKETTIMEDOUT", "ETIMEDOUT", "ECONNREFUSED", "EHOSTUNREACH", "EPIPE", "EAI_AGAIN"];r.prototype._maybeRetry = function (t, e, n) {
      var r = !1;if (this.options.retryInterval) for (var o = 0, a = i.length; o < a; o++) {
        if (t.code === i[o]) {
          r = !0;break;
        }
      }r ? this._retryApiRequest(e, n) : n(t);
    }, r.prototype._retryApiRequest = function (t, e) {
      this.retryQueue.push({ item: t, callback: e }), this.retryHandle || (this.retryHandle = setInterval(function () {
        for (; this.retryQueue.length;) {
          var t = this.retryQueue.shift();this._makeApiRequest(t.item, t.callback);
        }
      }.bind(this), this.options.retryInterval));
    }, r.prototype._dequeuePendingRequest = function (t) {
      var e = this.pendingRequests.indexOf(t);e !== -1 && (this.pendingRequests.splice(e, 1), this._maybeCallWait());
    }, r.prototype._maybeLog = function (t, e) {
      if (this.logger && this.options.verbose) {
        var n = e;if (n = n || o.get(t, "body.trace.exception.message"), n = n || o.get(t, "body.trace_chain.0.exception.message")) return void this.logger.error(n);n = o.get(t, "body.message.body"), n && this.logger.log(n);
      }
    }, r.prototype._maybeCallWait = function () {
      return !(!o.isFunction(this.waitCallback) || 0 !== this.pendingItems.length || 0 !== this.pendingRequests.length) && (this.waitIntervalID && (this.waitIntervalID = clearInterval(this.waitIntervalID)), this.waitCallback(), !0);
    }, t.exports = r;
  }, function (t, e, n) {
    "use strict";
    function r() {
      if (!A && (A = !0, c(JSON) && (s(JSON.stringify) && (j.stringify = JSON.stringify), s(JSON.parse) && (j.parse = JSON.parse)), !a(j.stringify) || !a(j.parse))) {
        var t = n(8);t(j);
      }
    }function o(t, e) {
      return e === i(t);
    }function i(t) {
      var e = typeof t === "undefined" ? "undefined" : _typeof(t);return "object" !== e ? e : t ? t instanceof Error ? "error" : {}.toString.call(t).match(/\s([a-zA-Z]+)/)[1].toLowerCase() : "null";
    }function a(t) {
      return o(t, "function");
    }function s(t) {
      var e = /[\\^$.*+?()[\]{}|]/g,
          n = Function.prototype.toString.call(Object.prototype.hasOwnProperty).replace(e, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?"),
          r = RegExp("^" + n + "$");return u(t) && r.test(t);
    }function u(t) {
      var e = typeof t === "undefined" ? "undefined" : _typeof(t);return null != t && ("object" == e || "function" == e);
    }function c(t) {
      return !o(t, "undefined");
    }function l(t) {
      var e = i(t);return "object" === e || "array" === e;
    }function p(t) {
      return o(t, "error");
    }function f(t, e, n) {
      var r,
          i,
          a,
          s = o(t, "object"),
          u = o(t, "array"),
          c = [];if (s && n.indexOf(t) !== -1) return t;if (n.push(t), s) for (r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && c.push(r);
      } else if (u) for (a = 0; a < t.length; ++a) {
        c.push(a);
      }for (a = 0; a < c.length; ++a) {
        r = c[a], i = t[r], t[r] = e(r, i, n);
      }return t;
    }function h() {
      return "********";
    }function d() {
      var t = L(),
          e = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (e) {
        var n = (t + 16 * Math.random()) % 16 | 0;return t = Math.floor(t / 16), ("x" === e ? n : 7 & n | 8).toString(16);
      });return e;
    }function m(t) {
      var e = g(t);return "" === e.anchor && (e.source = e.source.replace("#", "")), t = e.source.replace("?" + e.query, "");
    }function g(t) {
      if (!o(t, "string")) throw new Error("received invalid input");for (var e = D, n = e.parser[e.strictMode ? "strict" : "loose"].exec(t), r = {}, i = e.key.length; i--;) {
        r[e.key[i]] = n[i] || "";
      }return r[e.q.name] = {}, r[e.key[12]].replace(e.q.parser, function (t, n, o) {
        n && (r[e.q.name][n] = o);
      }), r;
    }function v(t, e, n) {
      n = n || {}, n.access_token = t;var r,
          o = [];for (r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && o.push([r, n[r]].join("="));
      }var i = "?" + o.sort().join("&");e = e || {}, e.path = e.path || "";var a,
          s = e.path.indexOf("?"),
          u = e.path.indexOf("#");s !== -1 && (u === -1 || u > s) ? (a = e.path, e.path = a.substring(0, s) + i + "&" + a.substring(s + 1)) : u !== -1 ? (a = e.path, e.path = a.substring(0, u) + i + a.substring(u)) : e.path = e.path + i;
    }function y(t, e) {
      if (e = e || t.protocol, !e && t.port && (80 === t.port ? e = "http:" : 443 === t.port && (e = "https:")), e = e || "https:", !t.hostname) return null;var n = e + "//" + t.hostname;return t.port && (n = n + ":" + t.port), t.path && (n += t.path), n;
    }function b(t, e) {
      var n, r;try {
        n = j.stringify(t);
      } catch (o) {
        if (e && a(e)) try {
          n = e(t);
        } catch (t) {
          r = t;
        } else r = o;
      }return { error: r, value: n };
    }function w(t) {
      var e, n;try {
        e = j.parse(t);
      } catch (t) {
        n = t;
      }return { error: n, value: e };
    }function _(t, e, n, r, o, i, a, s) {
      var u = { url: e || "", line: n, column: r };u.func = s.guessFunctionName(u.url, u.line), u.context = s.gatherContext(u.url, u.line);var c = document && document.location && document.location.href,
          l = window && window.navigator && window.navigator.userAgent;return { mode: i, message: o ? String(o) : t || a, url: c, stack: [u], useragent: l };
    }function x(t, e) {
      return function (n, r) {
        try {
          e(n, r);
        } catch (e) {
          t.error(e);
        }
      };
    }function E(t, e, n, r, o) {
      for (var a, s, u, c, l, p, f = [], h = 0, m = t.length; h < m; ++h) {
        p = t[h];var g = i(p);switch (g) {case "undefined":
            break;case "string":
            a ? f.push(p) : a = p;break;case "function":
            c = x(e, p);break;case "date":
            f.push(p);break;case "error":case "domexception":
            s ? f.push(p) : s = p;break;case "object":case "array":
            if (p instanceof Error || "undefined" != typeof DOMException && p instanceof DOMException) {
              s ? f.push(p) : s = p;break;
            }if (r && "object" === g && !l) {
              for (var v = 0, y = r.length; v < y; ++v) {
                if (void 0 !== p[r[v]]) {
                  l = p;break;
                }
              }if (l) break;
            }u ? f.push(p) : u = p;break;default:
            if (p instanceof Error || "undefined" != typeof DOMException && p instanceof DOMException) {
              s ? f.push(p) : s = p;break;
            }f.push(p);}
      }f.length > 0 && (u = C(!0, {}, u), u.extraArgs = f);var b = { message: a, err: s, custom: u, timestamp: L(), callback: c, uuid: d() };return u && void 0 !== u.level && (b.level = u.level, delete u.level), r && l && (b.request = l), o && (b.lambdaContext = o), b._originalArgs = t, b;
    }function k(t, e) {
      if (t) {
        var n = e.split("."),
            r = t;try {
          for (var o = 0, i = n.length; o < i; ++o) {
            r = r[n[o]];
          }
        } catch (t) {
          r = void 0;
        }return r;
      }
    }function I(t, e, n) {
      if (t) {
        var r = e.split("."),
            o = r.length;if (!(o < 1)) {
          if (1 === o) return void (t[r[0]] = n);try {
            for (var i = t[r[0]] || {}, a = i, s = 1; s < o - 1; s++) {
              i[r[s]] = i[r[s]] || {}, i = i[r[s]];
            }i[r[o - 1]] = n, t[r[0]] = a;
          } catch (t) {
            return;
          }
        }
      }
    }function T(t, e) {
      function n(t, e, n, r, o, i) {
        return e + h(i);
      }function r(t) {
        var e;if (o(t, "string")) for (e = 0; e < u.length; ++e) {
          t = t.replace(u[e], n);
        }return t;
      }function i(t, e) {
        var n;for (n = 0; n < s.length; ++n) {
          if (s[n].test(t)) {
            e = h(e);break;
          }
        }return e;
      }function a(t, e, n) {
        var s = i(t, e);return s === e ? o(e, "object") || o(e, "array") ? f(e, a, n) : r(s) : s;
      }e = e || [];var s = S(e),
          u = O(e);return f(t, a, []), t;
    }function S(t) {
      for (var e, n = [], r = 0; r < t.length; ++r) {
        e = "\\[?(%5[bB])?" + t[r] + "\\[?(%5[bB])?\\]?(%5[dD])?", n.push(new RegExp(e, "i"));
      }return n;
    }function O(t) {
      for (var e, n = [], r = 0; r < t.length; ++r) {
        e = "\\[?(%5[bB])?" + t[r] + "\\[?(%5[bB])?\\]?(%5[dD])?", n.push(new RegExp("(" + e + "=)([^&\\n]+)", "igm"));
      }return n;
    }function N(t) {
      var e,
          n,
          r,
          o = [];for (e = 0, n = t.length; e < n; e++) {
        r = t[e], "object" == (typeof r === "undefined" ? "undefined" : _typeof(r)) ? (r = b(r), r = r.error || r.value, r.length > 500 && (r = r.substr(0, 500) + "...")) : "undefined" == typeof r && (r = "undefined"), o.push(r);
      }return o.join(" ");
    }function L() {
      return Date.now ? +Date.now() : +new Date();
    }var C = n(7),
        j = {},
        A = !1;r();var R = { debug: 0, info: 1, warning: 2, error: 3, critical: 4 },
        D = { strictMode: !1, key: ["source", "protocol", "authority", "userInfo", "user", "password", "host", "port", "relative", "path", "directory", "file", "query", "anchor"], q: { name: "queryKey", parser: /(?:^|&)([^&=]*)=?([^&]*)/g }, parser: { strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/, loose: /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/ } };t.exports = { isType: o, typeName: i, isFunction: a, isNativeFunction: s, isIterable: l, isError: p, extend: C, traverse: f, redact: h, uuid4: d, LEVELS: R, sanitizeUrl: m, addParamsAndAccessTokenToPath: v, formatUrl: y, stringify: b, jsonParse: w, makeUnhandledStackInfo: _, createItem: E, get: k, set: I, scrub: T, formatArgsAsString: N, now: L };
  }, function (t, e) {
    "use strict";
    var n = Object.prototype.hasOwnProperty,
        r = Object.prototype.toString,
        o = function o(t) {
      return "function" == typeof Array.isArray ? Array.isArray(t) : "[object Array]" === r.call(t);
    },
        i = function i(t) {
      if (!t || "[object Object]" !== r.call(t)) return !1;var e = n.call(t, "constructor"),
          o = t.constructor && t.constructor.prototype && n.call(t.constructor.prototype, "isPrototypeOf");if (t.constructor && !e && !o) return !1;var i;for (i in t) {}return "undefined" == typeof i || n.call(t, i);
    };t.exports = function t() {
      var e,
          n,
          r,
          a,
          s,
          u,
          c = arguments[0],
          l = 1,
          p = arguments.length,
          f = !1;for ("boolean" == typeof c ? (f = c, c = arguments[1] || {}, l = 2) : ("object" != (typeof c === "undefined" ? "undefined" : _typeof(c)) && "function" != typeof c || null == c) && (c = {}); l < p; ++l) {
        if (e = arguments[l], null != e) for (n in e) {
          r = c[n], a = e[n], c !== a && (f && a && (i(a) || (s = o(a))) ? (s ? (s = !1, u = r && o(r) ? r : []) : u = r && i(r) ? r : {}, c[n] = t(f, u, a)) : "undefined" != typeof a && (c[n] = a));
        }
      }return c;
    };
  }, function (t, e) {
    var n = function n(t) {
      function e(t) {
        return t < 10 ? "0" + t : t;
      }function n() {
        return this.valueOf();
      }function r(t) {
        return i.lastIndex = 0, i.test(t) ? '"' + t.replace(i, function (t) {
          var e = u[t];return "string" == typeof e ? e : "\\u" + ("0000" + t.charCodeAt(0).toString(16)).slice(-4);
        }) + '"' : '"' + t + '"';
      }function o(t, e) {
        var n,
            i,
            u,
            l,
            p,
            f = a,
            h = e[t];switch (h && "object" == (typeof h === "undefined" ? "undefined" : _typeof(h)) && "function" == typeof h.toJSON && (h = h.toJSON(t)), "function" == typeof c && (h = c.call(e, t, h)), typeof h === "undefined" ? "undefined" : _typeof(h)) {case "string":
            return r(h);case "number":
            return isFinite(h) ? String(h) : "null";case "boolean":case "null":
            return String(h);case "object":
            if (!h) return "null";if (a += s, p = [], "[object Array]" === Object.prototype.toString.apply(h)) {
              for (l = h.length, n = 0; n < l; n += 1) {
                p[n] = o(n, h) || "null";
              }return u = 0 === p.length ? "[]" : a ? "[\n" + a + p.join(",\n" + a) + "\n" + f + "]" : "[" + p.join(",") + "]", a = f, u;
            }if (c && "object" == (typeof c === "undefined" ? "undefined" : _typeof(c))) for (l = c.length, n = 0; n < l; n += 1) {
              "string" == typeof c[n] && (i = c[n], u = o(i, h), u && p.push(r(i) + (a ? ": " : ":") + u));
            } else for (i in h) {
              Object.prototype.hasOwnProperty.call(h, i) && (u = o(i, h), u && p.push(r(i) + (a ? ": " : ":") + u));
            }return u = 0 === p.length ? "{}" : a ? "{\n" + a + p.join(",\n" + a) + "\n" + f + "}" : "{" + p.join(",") + "}", a = f, u;}
      }var i = /[\\"\u0000-\u001f\u007f-\u009f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;"function" != typeof Date.prototype.toJSON && (Date.prototype.toJSON = function () {
        return isFinite(this.valueOf()) ? this.getUTCFullYear() + "-" + e(this.getUTCMonth() + 1) + "-" + e(this.getUTCDate()) + "T" + e(this.getUTCHours()) + ":" + e(this.getUTCMinutes()) + ":" + e(this.getUTCSeconds()) + "Z" : null;
      }, Boolean.prototype.toJSON = n, Number.prototype.toJSON = n, String.prototype.toJSON = n);var a, s, u, c;"function" != typeof t.stringify && (u = { "\b": "\\b", "\t": "\\t", "\n": "\\n", "\f": "\\f", "\r": "\\r", '"': '\\"', "\\": "\\\\" }, t.stringify = function (t, e, n) {
        var r;if (a = "", s = "", "number" == typeof n) for (r = 0; r < n; r += 1) {
          s += " ";
        } else "string" == typeof n && (s = n);if (c = e, e && "function" != typeof e && ("object" != (typeof e === "undefined" ? "undefined" : _typeof(e)) || "number" != typeof e.length)) throw new Error("JSON.stringify");return o("", { "": t });
      }), "function" != typeof t.parse && (t.parse = function () {
        function t(t) {
          return t.replace(/\\(?:u(.{4})|([^u]))/g, function (t, e, n) {
            return e ? String.fromCharCode(parseInt(e, 16)) : a[n];
          });
        }var e,
            n,
            r,
            o,
            i,
            a = { "\\": "\\", '"': '"', "/": "/", t: "\t", n: "\n", r: "\r", f: "\f", b: "\b" },
            s = { go: function go() {
            e = "ok";
          }, firstokey: function firstokey() {
            o = i, e = "colon";
          }, okey: function okey() {
            o = i, e = "colon";
          }, ovalue: function ovalue() {
            e = "ocomma";
          }, firstavalue: function firstavalue() {
            e = "acomma";
          }, avalue: function avalue() {
            e = "acomma";
          } },
            u = { go: function go() {
            e = "ok";
          }, ovalue: function ovalue() {
            e = "ocomma";
          }, firstavalue: function firstavalue() {
            e = "acomma";
          }, avalue: function avalue() {
            e = "acomma";
          } },
            c = { "{": { go: function go() {
              n.push({ state: "ok" }), r = {}, e = "firstokey";
            }, ovalue: function ovalue() {
              n.push({ container: r, state: "ocomma", key: o }), r = {}, e = "firstokey";
            }, firstavalue: function firstavalue() {
              n.push({ container: r, state: "acomma" }), r = {}, e = "firstokey";
            }, avalue: function avalue() {
              n.push({ container: r, state: "acomma" }), r = {}, e = "firstokey";
            } }, "}": { firstokey: function firstokey() {
              var t = n.pop();i = r, r = t.container, o = t.key, e = t.state;
            }, ocomma: function ocomma() {
              var t = n.pop();r[o] = i, i = r, r = t.container, o = t.key, e = t.state;
            } }, "[": { go: function go() {
              n.push({ state: "ok" }), r = [], e = "firstavalue";
            }, ovalue: function ovalue() {
              n.push({ container: r, state: "ocomma", key: o }), r = [], e = "firstavalue";
            }, firstavalue: function firstavalue() {
              n.push({ container: r, state: "acomma" }), r = [], e = "firstavalue";
            }, avalue: function avalue() {
              n.push({ container: r, state: "acomma" }), r = [], e = "firstavalue";
            } }, "]": { firstavalue: function firstavalue() {
              var t = n.pop();i = r, r = t.container, o = t.key, e = t.state;
            }, acomma: function acomma() {
              var t = n.pop();r.push(i), i = r, r = t.container, o = t.key, e = t.state;
            } }, ":": { colon: function colon() {
              if (Object.hasOwnProperty.call(r, o)) throw new SyntaxError("Duplicate key '" + o + '"');e = "ovalue";
            } }, ",": { ocomma: function ocomma() {
              r[o] = i, e = "okey";
            }, acomma: function acomma() {
              r.push(i), e = "avalue";
            } }, true: { go: function go() {
              i = !0, e = "ok";
            }, ovalue: function ovalue() {
              i = !0, e = "ocomma";
            }, firstavalue: function firstavalue() {
              i = !0, e = "acomma";
            }, avalue: function avalue() {
              i = !0, e = "acomma";
            } }, false: { go: function go() {
              i = !1, e = "ok";
            }, ovalue: function ovalue() {
              i = !1, e = "ocomma";
            }, firstavalue: function firstavalue() {
              i = !1, e = "acomma";
            }, avalue: function avalue() {
              i = !1, e = "acomma";
            } }, null: { go: function go() {
              i = null, e = "ok";
            }, ovalue: function ovalue() {
              i = null, e = "ocomma";
            }, firstavalue: function firstavalue() {
              i = null, e = "acomma";
            }, avalue: function avalue() {
              i = null, e = "acomma";
            } } };return function (r, o) {
          var a,
              l = /^[\u0020\t\n\r]*(?:([,:\[\]{}]|true|false|null)|(-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)|"((?:[^\r\n\t\\\"]|\\(?:["\\\/trnfb]|u[0-9a-fA-F]{4}))*)")/;e = "go", n = [];try {
            for (;;) {
              if (a = l.exec(r), !a) break;a[1] ? c[a[1]][e]() : a[2] ? (i = +a[2], u[e]()) : (i = t(a[3]), s[e]()), r = r.slice(a[0].length);
            }
          } catch (t) {
            e = t;
          }if ("ok" !== e || /[^\u0020\t\n\r]/.test(r)) throw e instanceof SyntaxError ? e : new SyntaxError("JSON");return "function" == typeof o ? function t(e, n) {
            var r,
                a,
                s = e[n];if (s && "object" == (typeof s === "undefined" ? "undefined" : _typeof(s))) for (r in i) {
              Object.prototype.hasOwnProperty.call(s, r) && (a = t(s, r), void 0 !== a ? s[r] = a : delete s[r]);
            }return o.call(e, n, s);
          }({ "": i }, "") : i;
        };
      }());
    };t.exports = n;
  }, function (t, e, n) {
    "use strict";
    function r(t, e) {
      this.queue = t, this.options = e, this.transforms = [];
    }var o = n(6);r.prototype.configure = function (t) {
      this.queue && this.queue.configure(t);var e = this.options;return this.options = o.extend(!0, {}, e, t), this;
    }, r.prototype.addTransform = function (t) {
      return o.isFunction(t) && this.transforms.push(t), this;
    }, r.prototype.log = function (t, e) {
      if (e && o.isFunction(e) || (e = function e() {}), !this.options.enabled) return e(new Error("Rollbar is not enabled"));this.queue.addPendingItem(t);var n = t.err;this._applyTransforms(t, function (r, o) {
        return r ? (this.queue.removePendingItem(t), e(r, null)) : void this.queue.addItem(o, e, n, t);
      }.bind(this));
    }, r.prototype._applyTransforms = function (t, e) {
      var n = -1,
          r = this.transforms.length,
          o = this.transforms,
          i = this.options,
          a = function a(t, s) {
        return t ? void e(t, null) : (n++, n === r ? void e(null, s) : void o[n](s, i, a));
      };a(null, t);
    }, t.exports = r;
  }, function (t, e, n) {
    "use strict";
    function r(t) {
      this.queue = [], this.options = i.extend(!0, {}, t);var e = this.options.maxTelemetryEvents || a;this.maxQueueSize = Math.max(0, Math.min(e, a));
    }function o(t, e) {
      if (e) return e;var n = { error: "error", manual: "info" };return n[t] || "info";
    }var i = n(6),
        a = 100;r.prototype.configure = function (t) {
      var e = this.options;this.options = i.extend(!0, {}, e, t);var n = this.options.maxTelemetryEvents || a,
          r = Math.max(0, Math.min(n, a)),
          o = 0;this.maxQueueSize > r && (o = this.maxQueueSize - r), this.maxQueueSize = r, this.queue.splice(0, o);
    }, r.prototype.copyEvents = function () {
      return Array.prototype.slice.call(this.queue, 0);
    }, r.prototype.capture = function (t, e, n, r, a) {
      var s = { level: o(t, n), type: t, timestamp_ms: a || i.now(), body: e, source: "client" };return r && (s.uuid = r), this.push(s), s;
    }, r.prototype.captureEvent = function (t, e, n) {
      return this.capture("manual", t, e, n);
    }, r.prototype.captureError = function (t, e, n, r) {
      var o = { message: t.message || String(t) };return t.stack && (o.stack = t.stack), this.capture("error", o, e, n, r);
    }, r.prototype.captureLog = function (t, e, n, r) {
      return this.capture("log", { message: t }, e, n, r);
    }, r.prototype.captureNetwork = function (t, e, n) {
      e = e || "xhr", t.subtype = t.subtype || e;var r = this.levelFromStatus(t.status_code);return this.capture("network", t, r, n);
    }, r.prototype.levelFromStatus = function (t) {
      return t >= 200 && t < 400 ? "info" : 0 === t || t >= 400 ? "error" : "info";
    }, r.prototype.captureDom = function (t, e, n, r, o) {
      var i = { subtype: t, element: e };return void 0 !== n && (i.value = n), void 0 !== r && (i.checked = r), this.capture("dom", i, "info", o);
    }, r.prototype.captureNavigation = function (t, e, n) {
      return this.capture("navigation", { from: t, to: e }, "info", n);
    }, r.prototype.captureDomContentLoaded = function (t) {
      return this.capture("navigation", { subtype: "DOMContentLoaded" }, "info", void 0, t && t.getTime());
    }, r.prototype.captureLoad = function (t) {
      return this.capture("navigation", { subtype: "load" }, "info", void 0, t && t.getTime());
    }, r.prototype.captureConnectivityChange = function (t, e) {
      return this.captureNetwork({ change: t }, "connectivity", e);
    }, r.prototype._captureRollbarItem = function (t) {
      return t.err ? this.captureError(t.err, t.level, t.uuid, t.timestamp) : t.message ? this.captureLog(t.message, t.level, t.uuid, t.timestamp) : t.custom ? this.capture("log", t.custom, t.level, t.uuid, t.timestamp) : void 0;
    }, r.prototype.push = function (t) {
      this.queue.push(t), this.queue.length > this.maxQueueSize && this.queue.shift();
    }, t.exports = r;
  }, function (t, e, n) {
    "use strict";
    function r(t, e, n, r) {
      this.options = t, this.transport = e, this.url = n, this.jsonBackup = r, this.accessToken = t.accessToken, this.transportOptions = o(t, n);
    }function o(t, e) {
      return a.getTransportFromOptions(t, s, e);
    }var i = n(6),
        a = n(12),
        s = { hostname: "api.rollbar.com", path: "/api/1/item/", search: null, version: "1", protocol: "https:", port: 443 };r.prototype.postItem = function (t, e) {
      var n = a.transportOptions(this.transportOptions, "POST"),
          r = a.buildPayload(this.accessToken, t, this.jsonBackup);this.transport.post(this.accessToken, n, r, e);
    }, r.prototype.configure = function (t) {
      var e = this.oldOptions;return this.options = i.extend(!0, {}, e, t), this.transportOptions = o(this.options, this.url), void 0 !== this.options.accessToken && (this.accessToken = this.options.accessToken), this;
    }, t.exports = r;
  }, function (t, e, n) {
    "use strict";
    function r(t, e, n) {
      if (s.isType(e.context, "object")) {
        var r = s.stringify(e.context, n);r.error ? e.context = "Error: could not serialize 'context'" : e.context = r.value || "", e.context.length > 255 && (e.context = e.context.substr(0, 255));
      }return { access_token: t, data: e };
    }function o(t, e, n) {
      var r = e.hostname,
          o = e.protocol,
          i = e.port,
          a = e.path,
          s = e.search,
          u = t.proxy;if (t.endpoint) {
        var c = n.parse(t.endpoint);r = c.hostname, o = c.protocol, i = c.port, a = c.pathname, s = c.search;
      }return { hostname: r, protocol: o, port: i, path: a, search: s, proxy: u };
    }function i(t, e) {
      var n = t.protocol || "https:",
          r = t.port || ("http:" === n ? 80 : "https:" === n ? 443 : void 0),
          o = t.hostname,
          i = t.path;return t.search && (i += t.search), t.proxy && (i = n + "//" + o + i, o = t.proxy.host || t.proxy.hostname, r = t.proxy.port, n = t.proxy.protocol || n), { protocol: n, hostname: o, path: i, port: r, method: e };
    }function a(t, e) {
      var n = /\/$/.test(t),
          r = /^\//.test(e);return n && r ? e = e.substring(1) : n || r || (e = "/" + e), t + e;
    }var s = n(6);t.exports = { buildPayload: r, getTransportFromOptions: o, transportOptions: i, appendPathToPath: a };
  }, function (t, e, n) {
    "use strict";
    function r() {
      var t = Array.prototype.slice.call(arguments, 0);t.unshift("Rollbar:"), a.ieVersion() <= 8 ? console.error(s.formatArgsAsString(t)) : console.error.apply(console, t);
    }function o() {
      var t = Array.prototype.slice.call(arguments, 0);t.unshift("Rollbar:"), a.ieVersion() <= 8 ? console.info(s.formatArgsAsString(t)) : console.info.apply(console, t);
    }function i() {
      var t = Array.prototype.slice.call(arguments, 0);t.unshift("Rollbar:"), a.ieVersion() <= 8 ? console.log(s.formatArgsAsString(t)) : console.log.apply(console, t);
    }n(14);var a = n(15),
        s = n(6);t.exports = { error: r, info: o, log: i };
  }, function (t, e) {
    !function (t) {
      "use strict";
      t.console || (t.console = {});for (var e, n, r = t.console, o = function o() {}, i = ["memory"], a = "assert,clear,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn".split(","); e = i.pop();) {
        r[e] || (r[e] = {});
      }for (; n = a.pop();) {
        r[n] || (r[n] = o);
      }
    }("undefined" == typeof window ? this : window);
  }, function (t, e) {
    "use strict";
    function n() {
      var t;if (!document) return t;for (var e = 3, n = document.createElement("div"), r = n.getElementsByTagName("i"); n.innerHTML = "<!--[if gt IE " + ++e + "]><i></i><![endif]-->", r[0];) {}return e > 4 ? e : t;
    }var r = { ieVersion: n };t.exports = r;
  }, function (t, e) {
    "use strict";
    function n(t, e, n) {
      if (t) {
        var o;"function" == typeof e._rollbarOldOnError ? o = e._rollbarOldOnError : t.onerror && !t.onerror.belongsToShim && (o = t.onerror, e._rollbarOldOnError = o);var i = function i() {
          var n = Array.prototype.slice.call(arguments, 0);r(t, e, o, n);
        };i.belongsToShim = n, t.onerror = i;
      }
    }function r(t, e, n, r) {
      t._rollbarWrappedError && (r[4] || (r[4] = t._rollbarWrappedError), r[5] || (r[5] = t._rollbarWrappedError._rollbarContext), t._rollbarWrappedError = null), e.handleUncaughtException.apply(e, r), n && n.apply(t, r);
    }function o(t, e, n) {
      if (t) {
        "function" == typeof t._rollbarURH && t._rollbarURH.belongsToShim && t.removeEventListener("unhandledrejection", t._rollbarURH);var r = function r(t) {
          var n = t.reason,
              r = t.promise,
              o = t.detail;!n && o && (n = o.reason, r = o.promise), e && e.handleUnhandledRejection && e.handleUnhandledRejection(n, r);
        };r.belongsToShim = n, t._rollbarURH = r, t.addEventListener("unhandledrejection", r);
      }
    }function i(t, e, n) {
      if (t) {
        var r,
            o,
            i = "EventTarget,Window,Node,ApplicationCache,AudioTrackList,ChannelMergerNode,CryptoOperation,EventSource,FileReader,HTMLUnknownElement,IDBDatabase,IDBRequest,IDBTransaction,KeyOperation,MediaController,MessagePort,ModalWindow,Notification,SVGElementInstance,Screen,TextTrack,TextTrackCue,TextTrackList,WebSocket,WebSocketWorker,Worker,XMLHttpRequest,XMLHttpRequestEventTarget,XMLHttpRequestUpload".split(",");
        for (r = 0; r < i.length; ++r) {
          o = i[r], t[o] && t[o].prototype && a(e, t[o].prototype, n);
        }
      }
    }function a(t, e, n) {
      if (e.hasOwnProperty && e.hasOwnProperty("addEventListener")) {
        for (var r = e.addEventListener; r._rollbarOldAdd && r.belongsToShim;) {
          r = r._rollbarOldAdd;
        }var o = function o(e, n, _o) {
          r.call(this, e, t.wrap(n), _o);
        };o._rollbarOldAdd = r, o.belongsToShim = n, e.addEventListener = o;for (var i = e.removeEventListener; i._rollbarOldRemove && i.belongsToShim;) {
          i = i._rollbarOldRemove;
        }var a = function a(t, e, n) {
          i.call(this, t, e && e._rollbar_wrapped || e, n);
        };a._rollbarOldRemove = i, a.belongsToShim = n, e.removeEventListener = a;
      }
    }t.exports = { captureUncaughtExceptions: n, captureUnhandledRejections: o, wrapGlobals: i };
  }, function (t, e, n) {
    "use strict";
    function r(t, e, n, r, o) {
      r && l.isFunction(r) || (r = function r() {}), l.addParamsAndAccessTokenToPath(t, e, n);var a = "GET",
          s = l.formatUrl(e);i(t, s, a, null, r, o);
    }function o(t, e, n, r, o) {
      if (r && l.isFunction(r) || (r = function r() {}), !n) return r(new Error("Cannot send empty request"));var a = l.stringify(n);if (a.error) return r(a.error);var s = a.value,
          u = "POST",
          c = l.formatUrl(e);i(t, c, u, s, r, o);
    }function i(t, e, n, r, o, i) {
      var f;if (f = i ? i() : a(), !f) return o(new Error("No way to send a request"));try {
        try {
          var _h = function h() {
            try {
              if (_h && 4 === f.readyState) {
                _h = void 0;var t = l.jsonParse(f.responseText);if (s(f)) return void o(t.error, t.value);if (u(f)) {
                  if (403 === f.status) {
                    var e = t.value && t.value.message;p.error(e);
                  }o(new Error(String(f.status)));
                } else {
                  var n = "XHR response had no status code (likely connection failure)";o(c(n));
                }
              }
            } catch (t) {
              var r;r = t && t.stack ? t : new Error(t), o(r);
            }
          };f.open(n, e, !0), f.setRequestHeader && (f.setRequestHeader("Content-Type", "application/json"), f.setRequestHeader("X-Rollbar-Access-Token", t)), f.onreadystatechange = _h, f.send(r);
        } catch (t) {
          if ("undefined" != typeof XDomainRequest) {
            if (!window || !window.location) return o(new Error("No window available during request, unknown environment"));"http:" === window.location.href.substring(0, 5) && "https" === e.substring(0, 5) && (e = "http" + e.substring(5));var d = new XDomainRequest();d.onprogress = function () {}, d.ontimeout = function () {
              var t = "Request timed out",
                  e = "ETIMEDOUT";o(c(t, e));
            }, d.onerror = function () {
              o(new Error("Error during request"));
            }, d.onload = function () {
              var t = l.jsonParse(d.responseText);o(t.error, t.value);
            }, d.open(n, e, !0), d.send(r);
          } else o(new Error("Cannot find a method to transport a request"));
        }
      } catch (t) {
        o(t);
      }
    }function a() {
      var t,
          e,
          n = [function () {
        return new XMLHttpRequest();
      }, function () {
        return new ActiveXObject("Msxml2.XMLHTTP");
      }, function () {
        return new ActiveXObject("Msxml3.XMLHTTP");
      }, function () {
        return new ActiveXObject("Microsoft.XMLHTTP");
      }],
          r = n.length;for (e = 0; e < r; e++) {
        try {
          t = n[e]();break;
        } catch (t) {}
      }return t;
    }function s(t) {
      return t && t.status && 200 === t.status;
    }function u(t) {
      return t && l.isType(t.status, "number") && t.status >= 400 && t.status < 600;
    }function c(t, e) {
      var n = new Error(t);return n.code = e || "ENOTFOUND", n;
    }var l = n(6),
        p = n(13);t.exports = { get: r, post: o };
  }, function (t, e) {
    "use strict";
    function n(t) {
      var e,
          n,
          r = { protocol: null, auth: null, host: null, path: null, hash: null, href: t, hostname: null, port: null, pathname: null, search: null, query: null };if (e = t.indexOf("//"), e !== -1 ? (r.protocol = t.substring(0, e), n = e + 2) : n = 0, e = t.indexOf("@", n), e !== -1 && (r.auth = t.substring(n, e), n = e + 1), e = t.indexOf("/", n), e === -1) {
        if (e = t.indexOf("?", n), e === -1) return e = t.indexOf("#", n), e === -1 ? r.host = t.substring(n) : (r.host = t.substring(n, e), r.hash = t.substring(e)), r.hostname = r.host.split(":")[0], r.port = r.host.split(":")[1], r.port && (r.port = parseInt(r.port, 10)), r;r.host = t.substring(n, e), r.hostname = r.host.split(":")[0], r.port = r.host.split(":")[1], r.port && (r.port = parseInt(r.port, 10)), n = e;
      } else r.host = t.substring(n, e), r.hostname = r.host.split(":")[0], r.port = r.host.split(":")[1], r.port && (r.port = parseInt(r.port, 10)), n = e;if (e = t.indexOf("#", n), e === -1 ? r.path = t.substring(n) : (r.path = t.substring(n, e), r.hash = t.substring(e)), r.path) {
        var o = r.path.split("?");r.pathname = o[0], r.query = o[1], r.search = r.query ? "?" + r.query : null;
      }return r;
    }t.exports = { parse: n };
  }, function (t, e, n) {
    "use strict";
    function r(t, e, n) {
      if (t.data = t.data || {}, t.err) try {
        t.stackInfo = t.err._savedStackTrace || m.parse(t.err);
      } catch (e) {
        g.error("Error while parsing the error object.", e), t.message = t.err.message || t.err.description || t.message || String(t.err), delete t.err;
      }n(null, t);
    }function o(t, e, n) {
      t.message || t.stackInfo || t.custom || n(new Error("No message, stack info, or custom data"), null), n(null, t);
    }function i(t, e, n) {
      var r = e.payload && e.payload.environment || e.environment;t.data = d.extend(!0, {}, t.data, { environment: r, level: t.level, endpoint: e.endpoint, platform: "browser", framework: "browser-js", language: "javascript", server: {}, uuid: t.uuid, notifier: { name: "rollbar-browser-js", version: e.version } }), n(null, t);
    }function a(t) {
      return function (e, n, r) {
        return t && t.location ? (d.set(e, "data.request", { url: t.location.href, query_string: t.location.search, user_ip: "$remote_ip" }), void r(null, e)) : r(null, e);
      };
    }function s(t) {
      return function (e, n, r) {
        return t ? (d.set(e, "data.client", { runtime_ms: e.timestamp - t._rollbarStartTime, timestamp: Math.round(e.timestamp / 1e3), javascript: { browser: t.navigator.userAgent, language: t.navigator.language, cookie_enabled: t.navigator.cookieEnabled, screen: { width: t.screen.width, height: t.screen.height } } }), void r(null, e)) : r(null, e);
      };
    }function u(t) {
      return function (e, n, r) {
        if (!t || !t.navigator) return r(null, e);for (var o, i = [], a = t.navigator.plugins || [], s = 0, u = a.length; s < u; ++s) {
          o = a[s], i.push({ name: o.name, description: o.description });
        }d.set(e, "data.client.javascript.plugins", i), r(null, e);
      };
    }function c(t, e, n) {
      t.stackInfo ? p(t, e, n) : l(t, e, n);
    }function l(t, e, n) {
      var r = t.message,
          o = t.custom;if (!r) if (o) {
        var i = e.scrubFields,
            a = d.stringify(d.scrub(o, i));r = a.error || a.value || "";
      } else r = "";var s = { body: r };o && (s.extra = d.extend(!0, {}, o)), d.set(t, "data.body", { message: s }), n(null, t);
    }function p(t, e, n) {
      var r = t.data.description,
          o = t.stackInfo,
          i = t.custom,
          a = m.guessErrorClass(o.message),
          s = o.name || a[0],
          u = a[1],
          c = { exception: { class: s, message: u } };r && (c.exception.description = r);var p = o.stack;if (p && 0 === p.length && t._unhandledStackInfo && t._unhandledStackInfo.stack && (p = t._unhandledStackInfo.stack), p) {
        var f, h, g, v, y, b, w, _;for (c.frames = [], w = 0; w < p.length; ++w) {
          f = p[w], h = { filename: f.url ? d.sanitizeUrl(f.url) : "(unknown)", lineno: f.line || null, method: f.func && "?" !== f.func ? f.func : "[anonymous]", colno: f.column }, h.method && h.method.endsWith && h.method.endsWith("_rollbar_wrapped") || (g = v = y = null, b = f.context ? f.context.length : 0, b && (_ = Math.floor(b / 2), v = f.context.slice(0, _), g = f.context[_], y = f.context.slice(_)), g && (h.code = g), (v || y) && (h.context = {}, v && v.length && (h.context.pre = v), y && y.length && (h.context.post = y)), f.args && (h.args = f.args), c.frames.push(h));
        }c.frames.reverse(), i && (c.extra = d.extend(!0, {}, i)), d.set(t, "data.body", { trace: c }), n(null, t);
      } else t.message = s + ": " + u, l(t, e, n);
    }function f(t, e, n) {
      var r = e.scrubFields;d.scrub(t.data, r), n(null, t);
    }function h(t, e, n) {
      var r = d.extend(!0, {}, t);try {
        d.isFunction(e.transform) && e.transform(r.data);
      } catch (r) {
        return e.transform = null, g.error("Error while calling custom transform() function. Removing custom transform().", r), void n(null, t);
      }n(null, r);
    }var d = n(6),
        m = n(20),
        g = n(13);t.exports = { handleItemWithError: r, ensureItemHasSomethingToSay: o, addBaseInfo: i, addRequestInfo: a, addClientInfo: s, addPluginInfo: u, addBody: c, scrubPayload: f, userTransform: h };
  }, function (t, e, n) {
    "use strict";
    function r() {
      return l;
    }function o() {
      return null;
    }function i(t) {
      var e = {};return e._stackFrame = t, e.url = t.fileName, e.line = t.lineNumber, e.func = t.functionName, e.column = t.columnNumber, e.args = t.args, e.context = o(e.url, e.line), e;
    }function a(t) {
      function e() {
        var e = [];try {
          e = c.parse(t);
        } catch (t) {
          e = [];
        }for (var n = [], r = 0; r < e.length; r++) {
          n.push(new i(e[r]));
        }return n;
      }return { stack: e(), message: t.message, name: t.name };
    }function s(t) {
      return new a(t);
    }function u(t) {
      if (!t) return ["Unknown error. There was no error message to display.", ""];var e = t.match(p),
          n = "(unknown)";return e && (n = e[e.length - 1], t = t.replace((e[e.length - 2] || "") + n + ":", ""), t = t.replace(/(^[\s]+|[\s]+$)/g, "")), [n, t];
    }var c = n(21),
        l = "?",
        p = new RegExp("^(([a-zA-Z0-9-_$ ]*): *)?(Uncaught )?([a-zA-Z0-9-_$ ]*): ");t.exports = { guessFunctionName: r, guessErrorClass: u, gatherContext: o, parse: s, Stack: a, Frame: i };
  }, function (t, e, n) {
    var r, o, i;!function (a, s) {
      "use strict";
      o = [n(22)], r = s, i = "function" == typeof r ? r.apply(e, o) : r, !(void 0 !== i && (t.exports = i));
    }(this, function (t) {
      "use strict";
      function e(t, e, n) {
        if ("function" == typeof Array.prototype.map) return t.map(e, n);for (var r = new Array(t.length), o = 0; o < t.length; o++) {
          r[o] = e.call(n, t[o]);
        }return r;
      }function n(t, e, n) {
        if ("function" == typeof Array.prototype.filter) return t.filter(e, n);for (var r = [], o = 0; o < t.length; o++) {
          e.call(n, t[o]) && r.push(t[o]);
        }return r;
      }var r = /(^|@)\S+\:\d+/,
          o = /^\s*at .*(\S+\:\d+|\(native\))/m,
          i = /^(eval@)?(\[native code\])?$/;return { parse: function parse(t) {
          if ("undefined" != typeof t.stacktrace || "undefined" != typeof t["opera#sourceloc"]) return this.parseOpera(t);if (t.stack && t.stack.match(o)) return this.parseV8OrIE(t);if (t.stack) return this.parseFFOrSafari(t);throw new Error("Cannot parse given Error object");
        }, extractLocation: function extractLocation(t) {
          if (t.indexOf(":") === -1) return [t];var e = t.replace(/[\(\)\s]/g, "").split(":"),
              n = e.pop(),
              r = e[e.length - 1];if (!isNaN(parseFloat(r)) && isFinite(r)) {
            var o = e.pop();return [e.join(":"), o, n];
          }return [e.join(":"), n, void 0];
        }, parseV8OrIE: function parseV8OrIE(r) {
          var i = n(r.stack.split("\n"), function (t) {
            return !!t.match(o);
          }, this);return e(i, function (e) {
            e.indexOf("(eval ") > -1 && (e = e.replace(/eval code/g, "eval").replace(/(\(eval at [^\()]*)|(\)\,.*$)/g, ""));var n = e.replace(/^\s+/, "").replace(/\(eval code/g, "(").split(/\s+/).slice(1),
                r = this.extractLocation(n.pop()),
                o = n.join(" ") || void 0,
                i = "eval" === r[0] ? void 0 : r[0];return new t(o, void 0, i, r[1], r[2], e);
          }, this);
        }, parseFFOrSafari: function parseFFOrSafari(r) {
          var o = n(r.stack.split("\n"), function (t) {
            return !t.match(i);
          }, this);return e(o, function (e) {
            if (e.indexOf(" > eval") > -1 && (e = e.replace(/ line (\d+)(?: > eval line \d+)* > eval\:\d+\:\d+/g, ":$1")), e.indexOf("@") === -1 && e.indexOf(":") === -1) return new t(e);var n = e.split("@"),
                r = this.extractLocation(n.pop()),
                o = n.shift() || void 0;return new t(o, void 0, r[0], r[1], r[2], e);
          }, this);
        }, parseOpera: function parseOpera(t) {
          return !t.stacktrace || t.message.indexOf("\n") > -1 && t.message.split("\n").length > t.stacktrace.split("\n").length ? this.parseOpera9(t) : t.stack ? this.parseOpera11(t) : this.parseOpera10(t);
        }, parseOpera9: function parseOpera9(e) {
          for (var n = /Line (\d+).*script (?:in )?(\S+)/i, r = e.message.split("\n"), o = [], i = 2, a = r.length; i < a; i += 2) {
            var s = n.exec(r[i]);s && o.push(new t(void 0, void 0, s[2], s[1], void 0, r[i]));
          }return o;
        }, parseOpera10: function parseOpera10(e) {
          for (var n = /Line (\d+).*script (?:in )?(\S+)(?:: In function (\S+))?$/i, r = e.stacktrace.split("\n"), o = [], i = 0, a = r.length; i < a; i += 2) {
            var s = n.exec(r[i]);s && o.push(new t(s[3] || void 0, void 0, s[2], s[1], void 0, r[i]));
          }return o;
        }, parseOpera11: function parseOpera11(o) {
          var i = n(o.stack.split("\n"), function (t) {
            return !!t.match(r) && !t.match(/^Error created at/);
          }, this);return e(i, function (e) {
            var n,
                r = e.split("@"),
                o = this.extractLocation(r.pop()),
                i = r.shift() || "",
                a = i.replace(/<anonymous function(: (\w+))?>/, "$2").replace(/\([^\)]*\)/g, "") || void 0;i.match(/\(([^\)]*)\)/) && (n = i.replace(/^[^\(]+\(([^\)]*)\)$/, "$1"));var s = void 0 === n || "[arguments not available]" === n ? void 0 : n.split(",");return new t(a, s, o[0], o[1], o[2], e);
          }, this);
        } };
    });
  }, function (t, e, n) {
    var r, o, i;!function (n, a) {
      "use strict";
      o = [], r = a, i = "function" == typeof r ? r.apply(e, o) : r, !(void 0 !== i && (t.exports = i));
    }(this, function () {
      "use strict";
      function t(t) {
        return !isNaN(parseFloat(t)) && isFinite(t);
      }function e(t, e, n, r, o, i) {
        void 0 !== t && this.setFunctionName(t), void 0 !== e && this.setArgs(e), void 0 !== n && this.setFileName(n), void 0 !== r && this.setLineNumber(r), void 0 !== o && this.setColumnNumber(o), void 0 !== i && this.setSource(i);
      }return e.prototype = { getFunctionName: function getFunctionName() {
          return this.functionName;
        }, setFunctionName: function setFunctionName(t) {
          this.functionName = String(t);
        }, getArgs: function getArgs() {
          return this.args;
        }, setArgs: function setArgs(t) {
          if ("[object Array]" !== Object.prototype.toString.call(t)) throw new TypeError("Args must be an Array");this.args = t;
        }, getFileName: function getFileName() {
          return this.fileName;
        }, setFileName: function setFileName(t) {
          this.fileName = String(t);
        }, getLineNumber: function getLineNumber() {
          return this.lineNumber;
        }, setLineNumber: function setLineNumber(e) {
          if (!t(e)) throw new TypeError("Line Number must be a Number");this.lineNumber = Number(e);
        }, getColumnNumber: function getColumnNumber() {
          return this.columnNumber;
        }, setColumnNumber: function setColumnNumber(e) {
          if (!t(e)) throw new TypeError("Column Number must be a Number");this.columnNumber = Number(e);
        }, getSource: function getSource() {
          return this.source;
        }, setSource: function setSource(t) {
          this.source = String(t);
        }, toString: function toString() {
          var e = this.getFunctionName() || "{anonymous}",
              n = "(" + (this.getArgs() || []).join(",") + ")",
              r = this.getFileName() ? "@" + this.getFileName() : "",
              o = t(this.getLineNumber()) ? ":" + this.getLineNumber() : "",
              i = t(this.getColumnNumber()) ? ":" + this.getColumnNumber() : "";return e + n + r + o + i;
        } }, e;
    });
  }, function (t, e, n) {
    "use strict";
    function r(t, e, n) {
      var r = e.payload || {};r.body && delete r.body;var o = a.extend(!0, {}, t.data, r);t._isUncaught && (o._isUncaught = !0), t._originalArgs && (o._originalArgs = t._originalArgs), n(null, o);
    }function o(t, e, n) {
      t.telemetryEvents && a.set(t, "data.body.telemetry", t.telemetryEvents), n(null, t);
    }function i(t, e, n) {
      if (!t.message) return void n(null, t);var r = "data.body.trace_chain.0",
          o = a.get(t, r);if (o || (r = "data.body.trace", o = a.get(t, r)), o) {
        if (!o.exception || !o.exception.description) return a.set(t, r + ".exception.description", t.message), void n(null, t);var i = a.get(t, r + ".extra") || {},
            s = a.extend(!0, {}, i, { message: t.message });a.set(t, r + ".extra", s);
      }n(null, t);
    }var a = n(6);t.exports = { itemToPayload: r, addTelemetryData: o, addMessageWithError: i };
  }, function (t, e, n) {
    "use strict";
    function r(t, e) {
      var n = t.level,
          r = c.LEVELS[n] || 0,
          o = c.LEVELS[e.reportLevel] || 0;return !(r < o) && (!c.get(e, "plugins.jquery.ignoreAjaxErrors") || !c.get(t, "body.message.extra.isAjax"));
    }function o(t, e) {
      var n = !!t._isUncaught;delete t._isUncaught;var r = t._originalArgs;delete t._originalArgs;try {
        if (c.isFunction(e.checkIgnore) && e.checkIgnore(n, r, t)) return !1;
      } catch (t) {
        e.checkIgnore = null, l.error("Error while calling custom checkIgnore(), removing", t);
      }return !0;
    }function i(t, e) {
      return !s(t, e, "blacklist");
    }function a(t, e) {
      return s(t, e, "whitelist");
    }function s(t, e, n) {
      var r = !1;"blacklist" === n && (r = !0);var o, i, a, s, u, p, f, h, d, m;try {
        if (o = r ? e.hostBlackList : e.hostWhiteList, f = o && o.length, i = c.get(t, "body.trace"), !o || 0 === f) return !r;if (!i || !i.frames) return !r;for (u = i.frames.length, d = 0; d < u; d++) {
          if (a = i.frames[d], s = a.filename, !c.isType(s, "string")) return !r;for (m = 0; m < f; m++) {
            if (p = o[m], h = new RegExp(p), h.test(s)) return !0;
          }
        }
      } catch (t) {
        r ? e.hostBlackList = null : e.hostWhiteList = null;var g = r ? "hostBlackList" : "hostWhiteList";return l.error("Error while reading your configuration's " + g + " option. Removing custom " + g + ".", t), !r;
      }return !1;
    }function u(t, e) {
      var n, r, o, i, a, s, u, p, f;try {
        if (a = !1, o = e.ignoredMessages, !o || 0 === o.length) return !0;if (u = t.body, p = c.get(u, "trace.exception.message"), f = c.get(u, "message.body"), n = p || f, !n) return !0;for (i = o.length, r = 0; r < i && (s = new RegExp(o[r], "gi"), !(a = s.test(n))); r++) {}
      } catch (t) {
        e.ignoredMessages = null, l.error("Error while reading your configuration's ignoredMessages option. Removing custom ignoredMessages.");
      }return !a;
    }var c = n(6),
        l = n(13);t.exports = { checkIgnore: r, userCheckIgnore: o, urlIsNotBlacklisted: i, urlIsWhitelisted: a, messageIsIgnored: u };
  }, function (t, e, n) {
    "use strict";
    function r(t, e, n, r, o) {
      var i = t[e];t[e] = n(i), r && r[o].push([t, e, i]);
    }function o(t, e) {
      for (var n; t[e].length;) {
        n = t[e].shift(), n[0][n[1]] = n[2];
      }
    }function i(t, e, n, r, o) {
      var i = t.autoInstrument;t.enabled === !1 || i === !1 ? this.autoInstrument = {} : (a.isType(i, "object") || (i = c), this.autoInstrument = a.extend(!0, {}, c, i)), this.scrubTelemetryInputs = !!t.scrubTelemetryInputs, this.telemetryScrubber = t.telemetryScrubber, this.telemeter = e, this.rollbar = n, this._window = r || {}, this._document = o || {}, this.replacements = { network: [], log: [], navigation: [], connectivity: [] }, this.eventRemovers = { dom: [], connectivity: [] }, this._location = this._window.location, this._lastHref = this._location && this._location.href;
    }var a = n(6),
        s = n(18),
        u = n(26),
        c = { network: !0, log: !0, dom: !0, navigation: !0, connectivity: !0 };i.prototype.configure = function (t) {
      var e = t.autoInstrument,
          n = a.extend(!0, {}, this.autoInstrument);t.enabled === !1 || e === !1 ? this.autoInstrument = {} : (a.isType(e, "object") || (e = c), this.autoInstrument = a.extend(!0, {}, c, e)), this.instrument(n), void 0 !== t.scrubTelemetryInputs && (this.scrubTelemetryInputs = !!t.scrubTelemetryInputs), void 0 !== t.telemetryScrubber && (this.telemetryScrubber = t.telemetryScrubber);
    }, i.prototype.instrument = function (t) {
      !this.autoInstrument.network || t && t.network ? !this.autoInstrument.network && t && t.network && this.deinstrumentNetwork() : this.instrumentNetwork(), !this.autoInstrument.log || t && t.log ? !this.autoInstrument.log && t && t.log && this.deinstrumentConsole() : this.instrumentConsole(), !this.autoInstrument.dom || t && t.dom ? !this.autoInstrument.dom && t && t.dom && this.deinstrumentDom() : this.instrumentDom(), !this.autoInstrument.navigation || t && t.navigation ? !this.autoInstrument.navigation && t && t.navigation && this.deinstrumentNavigation() : this.instrumentNavigation(), !this.autoInstrument.connectivity || t && t.connectivity ? !this.autoInstrument.connectivity && t && t.connectivity && this.deinstrumentConnectivity() : this.instrumentConnectivity();
    }, i.prototype.deinstrumentNetwork = function () {
      o(this.replacements, "network");
    }, i.prototype.instrumentNetwork = function () {
      function t(t, n) {
        t in n && a.isFunction(n[t]) && r(n, t, function (t) {
          return e.rollbar.wrap(t);
        });
      }var e = this;if ("XMLHttpRequest" in this._window) {
        var n = this._window.XMLHttpRequest.prototype;r(n, "open", function (t) {
          return function (e, n) {
            return a.isType(n, "string") && (this.__rollbar_xhr = { method: e, url: n, status_code: null, start_time_ms: a.now(), end_time_ms: null }), t.apply(this, arguments);
          };
        }, this.replacements, "network"), r(n, "send", function (n) {
          return function (o) {
            function i() {
              if (s.__rollbar_xhr && (1 === s.readyState || 4 === s.readyState)) {
                null === s.__rollbar_xhr.status_code && (s.__rollbar_xhr.status_code = 0, s.__rollbar_event = e.telemeter.captureNetwork(s.__rollbar_xhr, "xhr")), 1 === s.readyState ? s.__rollbar_xhr.start_time_ms = a.now() : s.__rollbar_xhr.end_time_ms = a.now();try {
                  var t = s.status;t = 1223 === t ? 204 : t, s.__rollbar_xhr.status_code = t, s.__rollbar_event.level = e.telemeter.levelFromStatus(t);
                } catch (t) {}
              }
            }var s = this;return t("onload", s), t("onerror", s), t("onprogress", s), "onreadystatechange" in s && a.isFunction(s.onreadystatechange) ? r(s, "onreadystatechange", function (t) {
              return e.rollbar.wrap(t, void 0, i);
            }) : s.onreadystatechange = i, n.apply(this, arguments);
          };
        }, this.replacements, "network");
      }"fetch" in this._window && r(this._window, "fetch", function (t) {
        return function (n, r) {
          for (var o = new Array(arguments.length), i = 0, s = o.length; i < s; i++) {
            o[i] = arguments[i];
          }var u,
              c = o[0],
              l = "GET";a.isType(c, "string") ? u = c : (u = c.url, c.method && (l = c.method)), o[1] && o[1].method && (l = o[1].method);var p = { method: l, url: u, status_code: null, start_time_ms: a.now(), end_time_ms: null };return e.telemeter.captureNetwork(p, "fetch"), t.apply(this, o).then(function (t) {
            return p.end_time_ms = a.now(), p.status_code = t.status, t;
          });
        };
      }, this.replacements, "network");
    }, i.prototype.deinstrumentConsole = function () {
      if ("console" in this._window && this._window.console.log) for (var t; this.replacements.log.length;) {
        t = this.replacements.log.shift(), this._window.console[t[0]] = t[1];
      }
    }, i.prototype.instrumentConsole = function () {
      function t(t) {
        var r = n[t],
            o = n,
            i = "warn" === t ? "warning" : t;n[t] = function () {
          var t = Array.prototype.slice.call(arguments),
              n = a.formatArgsAsString(t);e.telemeter.captureLog(n, i), r && Function.prototype.apply.call(r, o, t);
        }, e.replacements.log.push([t, r]);
      }if ("console" in this._window && this._window.console.log) for (var e = this, n = this._window.console, r = ["debug", "info", "warn", "error", "log"], o = 0, i = r.length; o < i; o++) {
        t(r[o]);
      }
    }, i.prototype.deinstrumentDom = function () {
      ("addEventListener" in this._window || "attachEvent" in this._window) && this.removeListeners("dom");
    }, i.prototype.instrumentDom = function () {
      if ("addEventListener" in this._window || "attachEvent" in this._window) {
        var t = this.handleClick.bind(this),
            e = this.handleBlur.bind(this);this.addListener("dom", this._window, "click", "onclick", t, !0), this.addListener("dom", this._window, "blur", "onfocusout", e, !0);
      }
    }, i.prototype.handleClick = function (t) {
      try {
        var e = u.getElementFromEvent(t, this._document),
            n = e && e.tagName,
            r = u.isDescribedElement(e, "a") || u.isDescribedElement(e, "button");n && (r || u.isDescribedElement(e, "input", ["button", "submit"])) ? this.captureDomEvent("click", e) : u.isDescribedElement(e, "input", ["checkbox", "radio"]) && this.captureDomEvent("input", e, e.value, e.checked);
      } catch (t) {}
    }, i.prototype.handleBlur = function (t) {
      try {
        var e = u.getElementFromEvent(t, this._document);e && e.tagName && (u.isDescribedElement(e, "textarea") ? this.captureDomEvent("input", e, e.value) : u.isDescribedElement(e, "select") && e.options && e.options.length ? this.handleSelectInputChanged(e) : u.isDescribedElement(e, "input") && !u.isDescribedElement(e, "input", ["button", "submit", "hidden", "checkbox", "radio"]) && this.captureDomEvent("input", e, e.value));
      } catch (t) {}
    }, i.prototype.handleSelectInputChanged = function (t) {
      if (t.multiple) for (var e = 0; e < t.options.length; e++) {
        t.options[e].selected && this.captureDomEvent("input", t, t.options[e].value);
      } else t.selectedIndex >= 0 && t.options[t.selectedIndex] && this.captureDomEvent("input", t, t.options[t.selectedIndex].value);
    }, i.prototype.captureDomEvent = function (t, e, n, r) {
      if (void 0 !== n) if (this.scrubTelemetryInputs || "password" === u.getElementType(e)) n = "[scrubbed]";else if (this.telemetryScrubber) {
        var o = u.describeElement(e);this.telemetryScrubber(o) && (n = "[scrubbed]");
      }var i = u.elementArrayToString(u.treeToArray(e));this.telemeter.captureDom(t, i, n, r);
    }, i.prototype.deinstrumentNavigation = function () {
      var t = this._window.chrome,
          e = t && t.app && t.app.runtime,
          n = !e && this._window.history && this._window.history.pushState;n && o(this.replacements, "navigation");
    }, i.prototype.instrumentNavigation = function () {
      var t = this._window.chrome,
          e = t && t.app && t.app.runtime,
          n = !e && this._window.history && this._window.history.pushState;if (n) {
        var o = this;r(this._window, "onpopstate", function (t) {
          return function () {
            var e = o._location.href;o.handleUrlChange(o._lastHref, e), t && t.apply(this, arguments);
          };
        }, this.replacements, "navigation"), r(this._window.history, "pushState", function (t) {
          return function () {
            var e = arguments.length > 2 ? arguments[2] : void 0;return e && o.handleUrlChange(o._lastHref, e + ""), t.apply(this, arguments);
          };
        }, this.replacements, "navigation");
      }
    }, i.prototype.handleUrlChange = function (t, e) {
      var n = s.parse(this._location.href),
          r = s.parse(e),
          o = s.parse(t);this._lastHref = e, n.protocol === r.protocol && n.host === r.host && (e = r.path + (r.hash || "")), n.protocol === o.protocol && n.host === o.host && (t = o.path + (o.hash || "")), this.telemeter.captureNavigation(t, e);
    }, i.prototype.deinstrumentConnectivity = function () {
      ("addEventListener" in this._window || "body" in this._document) && (this._window.addEventListener ? this.removeListeners("connectivity") : o(this.replacements, "connectivity"));
    }, i.prototype.instrumentConnectivity = function () {
      if ("addEventListener" in this._window || "body" in this._document) if (this._window.addEventListener) this.addListener("connectivity", this._window, "online", void 0, function () {
        this.telemeter.captureConnectivityChange("online");
      }.bind(this), !0), this.addListener("connectivity", this._window, "offline", void 0, function () {
        this.telemeter.captureConnectivityChange("offline");
      }.bind(this), !0);else {
        var t = this;r(this._document.body, "ononline", function (e) {
          return function () {
            t.telemeter.captureConnectivityChange("online"), e && e.apply(this, arguments);
          };
        }, this.replacements, "connectivity"), r(this._document.body, "onoffline", function (e) {
          return function () {
            t.telemeter.captureConnectivityChange("offline"), e && e.apply(this, arguments);
          };
        }, this.replacements, "connectivity");
      }
    }, i.prototype.addListener = function (t, e, n, r, o, i) {
      e.addEventListener ? (e.addEventListener(n, o, i), this.eventRemovers[t].push(function () {
        e.removeEventListener(n, o, i);
      })) : r && (e.attachEvent(r, o), this.eventRemovers[t].push(function () {
        e.detachEvent(r, o);
      }));
    }, i.prototype.removeListeners = function (t) {
      for (var e; this.eventRemovers[t].length;) {
        (e = this.eventRemovers[t].shift())();
      }
    }, t.exports = i;
  }, function (t, e) {
    "use strict";
    function n(t) {
      return (t.getAttribute("type") || "").toLowerCase();
    }function r(t, e, r) {
      if (t.tagName.toLowerCase() !== e.toLowerCase()) return !1;if (!r) return !0;t = n(t);for (var o = 0; o < r.length; o++) {
        if (r[o] === t) return !0;
      }return !1;
    }function o(t, e) {
      return t.target ? t.target : e && e.elementFromPoint ? e.elementFromPoint(t.clientX, t.clientY) : void 0;
    }function i(t) {
      for (var e, n = 5, r = [], o = 0; t && o < n && (e = u(t), "html" !== e.tagName); o++) {
        r.unshift(e), t = t.parentNode;
      }return r;
    }function a(t) {
      for (var e, n, r = 80, o = " > ", i = o.length, a = [], u = 0, c = t.length - 1; c >= 0; c--) {
        if (e = s(t[c]), n = u + a.length * i + e.length, c < t.length - 1 && n >= r + 3) {
          a.unshift("...");break;
        }a.unshift(e), u += e.length;
      }return a.join(o);
    }function s(t) {
      if (!t || !t.tagName) return "";var e = [t.tagName];t.id && e.push("#" + t.id), t.classes && e.push("." + t.classes.join("."));for (var n = 0; n < t.attributes.length; n++) {
        e.push("[" + t.attributes[n].key + '="' + t.attributes[n].value + '"]');
      }return e.join("");
    }function u(t) {
      if (!t || !t.tagName) return null;var e,
          n,
          r,
          o,
          i = {};i.tagName = t.tagName.toLowerCase(), t.id && (i.id = t.id), e = t.className, e && "string" == typeof e && (i.classes = e.split(/\s+/));var a = ["type", "name", "title", "alt"];for (i.attributes = [], o = 0; o < a.length; o++) {
        n = a[o], r = t.getAttribute(n), r && i.attributes.push({ key: n, value: r });
      }return i;
    }t.exports = { describeElement: u, descriptionToString: s, elementArrayToString: a, treeToArray: i, getElementFromEvent: o, isDescribedElement: r, getElementType: n };
  }]);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(84)(module)))

/***/ })

},[390]);


// WEBPACK FOOTER //
// client.02af0a06.js